// THIS IS A GENERATED FILE
/* eslint-disable @typescript-eslint/no-explicit-any */
export type Maybe<T> = T extends Array<infer R>
  ? Array<Exclude<R, null>>
  : T | null
export type Exact<T extends { [key: string]: any }> = { [K in keyof T]: T[K] }

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  Date: any
  DateTime: any
  JSON: any
  USCurrency: any
  UUID: any
}

export type AcceptInvitationResult = {
  __typename?: "AcceptInvitationResult"
  mutationResult?: Maybe<MutationResult>
  redirectPath?: Maybe<Scalars["String"]>
  invitation?: Maybe<Invitation>
}

export type ActiveStaleBuildsResult = {
  __typename?: "ActiveStaleBuildsResult"
  active?: Maybe<Array<Maybe<Build>>>
  stale?: Maybe<Array<Maybe<Build>>>
}

export type AddUserToInvitationResult = {
  __typename?: "AddUserToInvitationResult"
  mutationResult?: Maybe<MutationResult>
  redirectPath?: Maybe<Scalars["String"]>
  invitation?: Maybe<Invitation>
}

export type AdditionalFeaturesInput = {
  name?: Maybe<Scalars["String"]>
  quantity?: Maybe<Scalars["Int"]>
}

export enum AdminPlanType {
  Inkteam = "INKTEAM",
  Partner = "PARTNER",
}

export enum AuthenticationProvider {
  Github = "GITHUB",
}

export type AzureConnectionInput = {
  connectionString: Scalars["String"]
  storageAccount: Scalars["String"]
}

export type BaseFeatures = {
  __typename?: "BaseFeatures"
  tier?: Maybe<MachinePricingTier>
  cloudBuilds?: Maybe<Scalars["Boolean"]>
  repositoryAccess?: Maybe<SubscriptionRepositoryType>
  domains?: Maybe<Scalars["Int"]>
  functionTimeout?: Maybe<Scalars["Int"]>
  thirdPartyHostingIntegrations?: Maybe<Scalars["Int"]>
  invocations?: Maybe<SubscriptionFeature>
  customSSL?: Maybe<Scalars["Boolean"]>
  sites?: Maybe<Scalars["Int"]>
  imageCdnRequests?: Maybe<SubscriptionFeature>
  monthlyBuildMinutes?: Maybe<SubscriptionFeature>
  totalSiteRoutes?: Maybe<SubscriptionFeature>
  requests?: Maybe<SubscriptionFeature>
  users?: Maybe<SubscriptionFeature>
  bandwidth?: Maybe<SubscriptionFeature>
  concurrency?: Maybe<SubscriptionFeature>
  internationalPopsTier?: Maybe<InternationalPopsTier>
}

export type BillingInformation = {
  __typename?: "BillingInformation"
  id: Scalars["UUID"]
  plan?: Maybe<SubscriptionPlan>
  status?: Maybe<SubscriptionStatus>
  trialDaysRemaining?: Maybe<Scalars["Int"]>
  trialStart?: Maybe<Scalars["DateTime"]>
  trialEnd?: Maybe<Scalars["DateTime"]>
  creditCard?: Maybe<CreditCard>
  nextBillingDate?: Maybe<Scalars["DateTime"]>
  subscriptionBillingStartDate?: Maybe<Scalars["DateTime"]>
  subscriptionBillingEndDate?: Maybe<Scalars["DateTime"]>
  subscriptionStartedAt?: Maybe<Scalars["DateTime"]>
  subscriptionChangedAt?: Maybe<Scalars["DateTime"]>
  canceledAt?: Maybe<Scalars["DateTime"]>
  stripeCustomerId?: Maybe<Scalars["String"]>
  cancelAtPeriodEnd?: Maybe<Scalars["Boolean"]>
  periodEnd?: Maybe<Scalars["DateTime"]>
}

export enum BillingInterval {
  Monthly = "MONTHLY",
  Annual = "ANNUAL",
  Quarterly = "QUARTERLY",
  Biannual = "BIANNUAL",
}

export type BranchListResults = {
  __typename?: "BranchListResults"
  branches?: Maybe<Array<Maybe<Scalars["String"]>>>
  pageInfo?: Maybe<GithubPagination>
}

export enum BranchType {
  Active = "ACTIVE",
  Stale = "STALE",
  Production = "PRODUCTION",
}

export type Build = {
  __typename?: "Build"
  id: Scalars["UUID"]
  siteId: Scalars["UUID"]
  branch?: Maybe<Scalars["String"]>
  siteName?: Maybe<Scalars["String"]>
  commitSha?: Maybe<Scalars["String"]>
  commitAuthor?: Maybe<Scalars["String"]>
  commitAuthorAvatar?: Maybe<Scalars["String"]>
  commitMessage?: Maybe<Scalars["String"]>
  commit?: Maybe<BuildCommit>
  pullRequest?: Maybe<PullRequest>
  author?: Maybe<User>
  externalId?: Maybe<Scalars["String"]>
  buildType: BuildType
  buildStatus: BuildStatus
  runnerType?: Maybe<BuildRunnerType>
  structuredBuild?: Maybe<Scalars["Boolean"]>
  createdAt: Scalars["DateTime"]
  startedAt?: Maybe<Scalars["DateTime"]>
  endedAt?: Maybe<Scalars["DateTime"]>
  deployStartedAt?: Maybe<Scalars["DateTime"]>
  deployEndedAt?: Maybe<Scalars["DateTime"]>
  duration?: Maybe<Scalars["Float"]>
  source?: Maybe<BuildSource>
  cdnVendor?: Maybe<Scalars["String"]>
  routeMetadata?: Maybe<BuildRouteMetadata>
  gatsbyConfig?: Maybe<BuildGatsbyConfig>
  metadata?: Maybe<BuildMetadata>
  url?: Maybe<Scalars["String"]>
}

export type BuildActivity = {
  __typename?: "BuildActivity"
  id: Scalars["UUID"]
  name?: Maybe<Scalars["String"]>
  message?: Maybe<Scalars["String"]>
  type: BuildActivityType
  status: BuildActivityStatus
  statusText?: Maybe<Scalars["String"]>
  duration?: Maybe<Scalars["Float"]>
  current?: Maybe<Scalars["Int"]>
  total?: Maybe<Scalars["Int"]>
}

export type BuildActivityCreateInput = {
  id?: Maybe<Scalars["String"]>
  uuid: Scalars["UUID"]
  type: BuildActivityType
  text?: Maybe<Scalars["String"]>
  status: BuildActivityStatus
  statusText?: Maybe<Scalars["String"]>
  duration?: Maybe<Scalars["Float"]>
  current?: Maybe<Scalars["Int"]>
  total?: Maybe<Scalars["Int"]>
}

export enum BuildActivityStatus {
  InProgress = "IN_PROGRESS",
  NotStarted = "NOT_STARTED",
  Failed = "FAILED",
  Interrupted = "INTERRUPTED",
  Success = "SUCCESS",
}

export enum BuildActivityType {
  Progress = "PROGRESS",
  Spinner = "SPINNER",
  Pending = "PENDING",
  Success = "SUCCESS",
  Hidden = "HIDDEN",
}

export type BuildActivityUpdateInput = {
  text?: Maybe<Scalars["String"]>
  statusText?: Maybe<Scalars["String"]>
  duration?: Maybe<Scalars["Float"]>
  current?: Maybe<Scalars["Int"]>
  total?: Maybe<Scalars["Int"]>
}

export type BuildBranchCounts = {
  __typename?: "BuildBranchCounts"
  total?: Maybe<Scalars["Int"]>
  active?: Maybe<Scalars["Int"]>
  stale?: Maybe<Scalars["Int"]>
}

export type BuildCommit = {
  __typename?: "BuildCommit"
  id: Scalars["ID"]
  login?: Maybe<Scalars["String"]>
  name?: Maybe<Scalars["String"]>
  sha: Scalars["String"]
  avatarUrl?: Maybe<Scalars["String"]>
  message: Scalars["String"]
}

export type BuildCommitInput = {
  login?: Maybe<Scalars["String"]>
  name?: Maybe<Scalars["String"]>
  sha: Scalars["String"]
  avatarUrl?: Maybe<Scalars["String"]>
  message: Scalars["String"]
}

export type BuildGatsbyConfig = {
  __typename?: "BuildGatsbyConfig"
  trailingSlash?: Maybe<Scalars["String"]>
  pathPrefix?: Maybe<Scalars["String"]>
  assetPrefix?: Maybe<Scalars["String"]>
  enableImageCdn?: Maybe<Scalars["Boolean"]>
  enableBuildFragments?: Maybe<Scalars["Boolean"]>
  staticFileBucketName?: Maybe<Scalars["String"]>
}

export type BuildMetadata = {
  __typename?: "BuildMetadata"
  burstMode?: Maybe<Scalars["Boolean"]>
  merlinSourced?: Maybe<Scalars["Boolean"]>
  imageCdnEncryption?: Maybe<ImageCdnEncryption>
}

export enum BuildQueueEvent {
  SourceUpdate = "SOURCE_UPDATE",
  DataUpdate = "DATA_UPDATE",
  Rebuild = "REBUILD",
  Reset = "RESET",
}

export type BuildResults = {
  __typename?: "BuildResults"
  pageInfo?: Maybe<CursorPageInfo>
  builds?: Maybe<Array<Maybe<Build>>>
  error?: Maybe<Scalars["String"]>
}

export type BuildRouteMetadata = {
  __typename?: "BuildRouteMetadata"
  ssgRouteCount: Scalars["Int"]
  ssrRouteCount: Scalars["Int"]
  dsgRouteCount: Scalars["Int"]
  functionRouteCount: Scalars["Int"]
  burstBuild?: Maybe<Scalars["Boolean"]>
  totalRenderedPageCount?: Maybe<Scalars["Int"]>
}

export enum BuildRunnerType {
  Preview = "PREVIEW",
  Builds = "BUILDS",
  Benchmark = "BENCHMARK",
  IncrementalBuilds = "INCREMENTAL_BUILDS",
}

export enum BuildSource {
  GithubEnterprise = "GITHUB_ENTERPRISE",
  Agility = "AGILITY",
  Bitbucket = "BITBUCKET",
  Drupal = "DRUPAL",
  Contentful = "CONTENTFUL",
  Contentstack = "CONTENTSTACK",
  Craftcms = "CRAFTCMS",
  Cosmicjs = "COSMICJS",
  Datocms = "DATOCMS",
  Flotiq = "FLOTIQ",
  GatsbyCloud = "GATSBY_CLOUD",
  Github = "GITHUB",
  Gitlab = "GITLAB",
  GitlabSelfManaged = "GITLAB_SELF_MANAGED",
  Kontent = "KONTENT",
  Prismic = "PRISMIC",
  Sanity = "SANITY",
  Strapi = "STRAPI",
  Shopify = "SHOPIFY",
  Wordpress = "WORDPRESS",
  Merlin = "MERLIN",
}

export enum BuildStatus {
  GitClone = "GIT_CLONE",
  GitCloneError = "GIT_CLONE_ERROR",
  GitPull = "GIT_PULL",
  GitPullError = "GIT_PULL_ERROR",
  DepInstall = "DEP_INSTALL",
  DepInstallError = "DEP_INSTALL_ERROR",
  Queued = "QUEUED",
  Canceled = "CANCELED",
  CanceledByGatsbyCloud = "CANCELED_BY_GATSBY_CLOUD",
  Building = "BUILDING",
  Uploading = "UPLOADING",
  Publishing = "PUBLISHING",
  UploadError = "UPLOAD_ERROR",
  PublishError = "PUBLISH_ERROR",
  PublishCanceled = "PUBLISH_CANCELED",
  TimedOut = "TIMED_OUT",
  Success = "SUCCESS",
  Error = "ERROR",
}

export enum BuildType {
  OrganizationActiveUpdate = "ORGANIZATION_ACTIVE_UPDATE",
  SourceUpdate = "SOURCE_UPDATE",
  DataUpdate = "DATA_UPDATE",
  SystemUpdate = "SYSTEM_UPDATE",
  EnvVarUpdate = "ENV_VAR_UPDATE",
  CdnUpdate = "CDN_UPDATE",
  ManualUpdate = "MANUAL_UPDATE",
}

export type CdnConfigInput = {
  config: Scalars["JSON"]
  vendor: CdnVendor
}

export type CdnIntegration = {
  __typename?: "CdnIntegration"
  id: Scalars["ID"]
  siteId?: Maybe<Scalars["UUID"]>
  vendor: CdnVendor
  connected: Scalars["Boolean"]
  config?: Maybe<Scalars["JSON"]>
}

export enum CdnVendor {
  Fastly = "FASTLY",
  Now = "NOW",
  Netlify = "NETLIFY",
  CloudCdn = "CLOUD_CDN",
  Firebase = "FIREBASE",
  S3 = "S3",
  Gcs = "GCS",
  Azure = "AZURE",
}

export enum CertificateStatus {
  NotRequested = "NOT_REQUESTED",
  Requested = "REQUESTED",
  Issued = "ISSUED",
  Deleted = "DELETED",
  Failed = "FAILED",
}

export type CloudFlag = {
  __typename?: "CloudFlag"
  id?: Maybe<Scalars["ID"]>
  name?: Maybe<Scalars["String"]>
  enabled?: Maybe<Scalars["Boolean"]>
}

export type CloudInputPath = {
  path?: Maybe<Scalars["String"]>
  contentDigest?: Maybe<Scalars["String"]>
  md5?: Maybe<Scalars["String"]>
  sha1?: Maybe<Scalars["String"]>
}

export type CloudInputPathReturn = {
  __typename?: "CloudInputPathReturn"
  path?: Maybe<Scalars["String"]>
  contentDigest?: Maybe<Scalars["String"]>
  md5?: Maybe<Scalars["String"]>
  sha1?: Maybe<Scalars["String"]>
}

export type CloudJob = {
  id?: Maybe<Scalars["UUID"]>
  name?: Maybe<Scalars["String"]>
  contentDigest?: Maybe<Scalars["String"]>
  inputPaths?: Maybe<Array<Maybe<CloudInputPath>>>
  pluginOptions?: Maybe<Scalars["JSON"]>
  outputDir?: Maybe<Scalars["String"]>
  args?: Maybe<Scalars["JSON"]>
  plugin?: Maybe<CloudJobPlugin>
}

export enum CloudJobError {
  Download = "DOWNLOAD",
  WorkerFunction = "WORKER_FUNCTION",
  Upload = "UPLOAD",
}

export type CloudJobPlugin = {
  name?: Maybe<Scalars["String"]>
  version?: Maybe<Scalars["String"]>
  resolve?: Maybe<Scalars["String"]>
  worker?: Maybe<Scalars["String"]>
  isLocal?: Maybe<Scalars["Boolean"]>
}

export type CloudJobResult = {
  id?: Maybe<Scalars["UUID"]>
  name?: Maybe<Scalars["String"]>
  contentDigest?: Maybe<Scalars["String"]>
  files?: Maybe<Array<Maybe<CloudInputPath>>>
  status?: Maybe<CloudJobStatus>
  cached?: Maybe<Scalars["Boolean"]>
  error?: Maybe<CloudJobError>
  result?: Maybe<Scalars["JSON"]>
}

export type CloudJobResultReturn = {
  __typename?: "CloudJobResultReturn"
  id?: Maybe<Scalars["UUID"]>
  name?: Maybe<Scalars["String"]>
  contentDigest?: Maybe<Scalars["String"]>
  siteId?: Maybe<Scalars["UUID"]>
  files?: Maybe<Array<Maybe<CloudInputPathReturn>>>
  status?: Maybe<CloudJobStatus>
  cached?: Maybe<Scalars["Boolean"]>
  error?: Maybe<CloudJobError>
  result?: Maybe<Scalars["JSON"]>
}

export enum CloudJobStatus {
  Success = "SUCCESS",
  Failed = "FAILED",
}

export type CloudResource = {
  __typename?: "CloudResource"
  resourceId: Scalars["UUID"]
  resourceType: CloudResourceType
  role: CloudRole
  name?: Maybe<Scalars["String"]>
  publicName?: Maybe<Scalars["String"]>
}

export enum CloudResourceType {
  Site = "SITE",
  Beta = "BETA",
  Organization = "ORGANIZATION",
  Account = "ACCOUNT",
}

export enum CloudRole {
  Owner = "OWNER",
  Admin = "ADMIN",
  Reader = "READER",
  LimitedContributor = "LIMITED_CONTRIBUTOR",
  LimitedReader = "LIMITED_READER",
  Contributor = "CONTRIBUTOR",
  Phantom = "PHANTOM",
}

export type CmsHealthCheck = {
  __typename?: "CmsHealthCheck"
  id?: Maybe<Scalars["ID"]>
  name?: Maybe<Scalars["String"]>
  url?: Maybe<Scalars["String"]>
  vendor: CmsVendor
  message?: Maybe<Scalars["String"]>
  status?: Maybe<CmsHealthCheckStatus>
}

export enum CmsHealthCheckStatus {
  Connected = "CONNECTED",
  Failed = "FAILED",
}

export type CmsIntegration = {
  __typename?: "CmsIntegration"
  id: Scalars["UUID"]
  vendor: CmsVendor
  status: CmsIntegrationStatus
  resourceId: Scalars["UUID"]
  integrationToken?: Maybe<Scalars["String"]>
  config?: Maybe<Scalars["JSON"]>
  environmentVariablesFeatureStatus?: Maybe<CmsIntegrationFeatureState>
  webhookFeatureStatus?: Maybe<CmsIntegrationFeatureState>
  extensionFeatureStatus?: Maybe<CmsIntegrationFeatureState>
}

export enum CmsIntegrationFeatureState {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
  Unavailable = "UNAVAILABLE",
}

export enum CmsIntegrationStatus {
  Connected = "CONNECTED",
  Disconnected = "DISCONNECTED",
  Errored = "ERRORED",
}

export type CmsProvider = {
  __typename?: "CmsProvider"
  id: Scalars["UUID"]
  name: CmsVendor
  formattedName?: Maybe<Scalars["String"]>
  description: Scalars["String"]
  details?: Maybe<Scalars["String"]>
  logoUrl: Scalars["String"]
  provisioningEnabled?: Maybe<Scalars["Boolean"]>
  integrationsEnabled?: Maybe<Scalars["Boolean"]>
  connected?: Maybe<Scalars["Boolean"]>
  features?: Maybe<IntegrationFeatures>
}

export type CmsProvisioningStarter = {
  __typename?: "CmsProvisioningStarter"
  id: Scalars["UUID"]
  vendor: CmsVendor
  formattedVendorName?: Maybe<Scalars["String"]>
  type: Scalars["String"]
  description: Scalars["String"]
  starterImageUrl: Scalars["String"]
  source: SourceControlProvider
  projectSlug: Scalars["String"]
  available?: Maybe<Scalars["Boolean"]>
}

export enum CmsVendor {
  Contentful = "CONTENTFUL",
  Contentstack = "CONTENTSTACK",
  Craftcms = "CRAFTCMS",
  Wordpress = "WORDPRESS",
  Drupal = "DRUPAL",
  Sanity = "SANITY",
  Datocms = "DATOCMS",
  Butter = "BUTTER",
  Storyblok = "STORYBLOK",
  Kentico = "KENTICO",
  Wings = "WINGS",
  Netlify = "NETLIFY",
  Flamelink = "FLAMELINK",
  Flotiq = "FLOTIQ",
  Dropbox = "DROPBOX",
  Plone = "PLONE",
  Prismic = "PRISMIC",
  Fridge = "FRIDGE",
  Zesty = "ZESTY",
  Cockpit = "COCKPIT",
  Directus = "DIRECTUS",
  Morty = "MORTY",
  Contenta = "CONTENTA",
  Huray = "HURAY",
  Blogger = "BLOGGER",
  Mes = "MES",
  Wahyu = "WAHYU",
  Transifex = "TRANSIFEX",
  Cosmicjs = "COSMICJS",
  Mdx = "MDX",
  Agility = "AGILITY",
  Kontent = "KONTENT",
  Strapi = "STRAPI",
  Shopify = "SHOPIFY",
  Custom = "CUSTOM",
  DataSync = "DATA_SYNC",
  None = "NONE",
  Markdown = "MARKDOWN",
}

export type ContentLoaderInfo = {
  __typename?: "ContentLoaderInfo"
  previewBuildStatus?: Maybe<BuildStatus>
  latestBuildStatus?: Maybe<BuildStatus>
  previewUrl?: Maybe<Scalars["String"]>
  stableBuildURL?: Maybe<Scalars["String"]>
  siteExists: Scalars["Boolean"]
  buildErrors?: Maybe<Array<Maybe<StructuredLog>>>
  orgId: Scalars["UUID"]
  previewBuildsEnabled: Scalars["Boolean"]
}

export type ContentfulOrganization = {
  __typename?: "ContentfulOrganization"
  id: Scalars["String"]
  name: Scalars["String"]
  selected?: Maybe<Scalars["Boolean"]>
  selectedSpace?: Maybe<Scalars["String"]>
  spaces?: Maybe<Array<Maybe<ContentfulSpace>>>
}

export type ContentfulSpace = {
  __typename?: "ContentfulSpace"
  id: Scalars["String"]
  name: Scalars["String"]
  selected: Scalars["Boolean"]
}

export type Contributor = {
  __typename?: "Contributor"
  id: Scalars["UUID"]
  name?: Maybe<Scalars["String"]>
  email: Scalars["String"]
  avatarUrl?: Maybe<Scalars["String"]>
  contributorRole: ContributorRole
  resources?: Maybe<Array<CloudResource>>
}

export type ContributorPermissionMap = {
  __typename?: "ContributorPermissionMap"
  invite?: Maybe<Scalars["Boolean"]>
  read?: Maybe<Scalars["Boolean"]>
  delete?: Maybe<Scalars["Boolean"]>
  deleteSelf?: Maybe<Scalars["Boolean"]>
}

export enum ContributorRole {
  Owner = "OWNER",
  Member = "MEMBER",
  Viewer = "VIEWER",
  Editor = "EDITOR",
  Admin = "ADMIN",
  Invited = "INVITED",
}

export type CosmicCmsBucket = {
  __typename?: "CosmicCmsBucket"
  id: Scalars["String"]
  name: Scalars["String"]
  selected?: Maybe<Scalars["Boolean"]>
}

export type CreateInvitationResult = {
  __typename?: "CreateInvitationResult"
  contributors?: Maybe<Array<Contributor>>
  validation: MutationResult
}

export type CreateRepositoryResult = {
  __typename?: "CreateRepositoryResult"
  repository?: Maybe<Repository>
  validation?: Maybe<MutationResult>
}

export type CreateSiteFromUrlResult = {
  __typename?: "CreateSiteFromUrlResult"
  siteInitJob?: Maybe<SiteInitJob>
  validation?: Maybe<MutationResult>
}

export type CreateSiteResult = {
  __typename?: "CreateSiteResult"
  site?: Maybe<Site>
  validation?: Maybe<MutationResult>
}

export type CreditCard = {
  __typename?: "CreditCard"
  name?: Maybe<Scalars["String"]>
  lastFour?: Maybe<Scalars["String"]>
  brand?: Maybe<CreditCardBrand>
  expMonth?: Maybe<Scalars["Int"]>
  expYear?: Maybe<Scalars["Int"]>
}

export enum CreditCardBrand {
  Amex = "AMEX",
  Diner = "DINER",
  Discover = "DISCOVER",
  Jcb = "JCB",
  Mastercard = "MASTERCARD",
  Unionpay = "UNIONPAY",
  Visa = "VISA",
  Unknown = "UNKNOWN",
}

export type CursorPageInfo = {
  __typename?: "CursorPageInfo"
  endCursor?: Maybe<Scalars["String"]>
  hasNextPage?: Maybe<Scalars["Boolean"]>
}

export type CursorPagination = {
  endCursor?: Maybe<Scalars["String"]>
  limit: Scalars["Int"]
}

export enum DataSourceProvider {
  Contentful = "CONTENTFUL",
  ContentfulSidebarExtension = "CONTENTFUL_SIDEBAR_EXTENSION",
}

export type Datapoint = {
  __typename?: "Datapoint"
  time: Scalars["DateTime"]
  value: Scalars["Int"]
  unit?: Maybe<MetricUnit>
}

export type DatoCmsProject = {
  __typename?: "DatoCmsProject"
  id: Scalars["String"]
  name: Scalars["String"]
  selected?: Maybe<Scalars["Boolean"]>
}

export type DependencyDiagnostic = {
  __typename?: "DependencyDiagnostic"
  id: Scalars["ID"]
  affectedVersions: Scalars["String"]
  patchedIn: Scalars["String"]
  overview?: Maybe<Scalars["String"]>
  paperTrail?: Maybe<Array<Maybe<Scalars["String"]>>>
}

export type DependencyDiagnosticInput = {
  id?: Maybe<Scalars["ID"]>
  affectedVersions: Scalars["String"]
  patchedIn: Scalars["String"]
  overview: Scalars["String"]
  paperTrail: Array<Scalars["String"]>
}

export enum DnsType {
  Cname = "CNAME",
  A = "A",
}

export type EnterpriseVcsConfig = {
  __typename?: "EnterpriseVcsConfig"
  id: Scalars["UUID"]
  workspaceId: Scalars["UUID"]
  config?: Maybe<Scalars["JSON"]>
}

export type FastlyConnectionInput = {
  serviceName: Scalars["String"]
  hostname?: Maybe<Scalars["String"]>
  accessToken: Scalars["String"]
  forceSSL?: Maybe<Scalars["Boolean"]>
  tlsKey?: Maybe<Scalars["String"]>
  tlsCert?: Maybe<Scalars["String"]>
}

export type FeaturesSummary = {
  __typename?: "FeaturesSummary"
  requests?: Maybe<SubscriptionFeature>
  imageCdnRequests?: Maybe<SubscriptionFeature>
  users?: Maybe<SubscriptionFeature>
  concurrency?: Maybe<SubscriptionFeature>
  bandwidth?: Maybe<SubscriptionFeature>
  invocations?: Maybe<SubscriptionFeature>
  totalSiteRoutes?: Maybe<SubscriptionFeature>
  monthlyBuildMinutes?: Maybe<SubscriptionFeature>
}

export type FirebaseResults = {
  __typename?: "FirebaseResults"
  items?: Maybe<Array<Maybe<FirebaseSite>>>
  error?: Maybe<Scalars["String"]>
  reauthorize?: Maybe<Scalars["Boolean"]>
}

export type FirebaseSite = {
  __typename?: "FirebaseSite"
  id: Scalars["ID"]
  name: Scalars["String"]
}

export type FullMerlinStatus = {
  __typename?: "FullMerlinStatus"
  status: MerlinStatus
  updatedAt: Scalars["DateTime"]
}

export type FunctionInvocation = {
  __typename?: "FunctionInvocation"
  id: Scalars["UUID"]
  functionId: Scalars["UUID"]
  logs: Array<Log>
  method: FunctionInvocationMethod
  status: Scalars["Int"]
  startedAt?: Maybe<Scalars["DateTime"]>
  endedAt?: Maybe<Scalars["DateTime"]>
}

export enum FunctionInvocationMethod {
  Get = "GET",
  Post = "POST",
  Put = "PUT",
  Delete = "DELETE",
  Options = "OPTIONS",
  Patch = "PATCH",
}

export type FunctionResourceLimits = {
  __typename?: "FunctionResourceLimits"
  maxScale: Scalars["Int"]
}

export enum FunctionStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}

export type GcsConnectionInput = {
  projectId: Scalars["String"]
  keyData: Scalars["String"]
  bucket: Scalars["String"]
  fileKeyPrefix?: Maybe<Scalars["String"]>
}

export type GatsbyCallSite = {
  __typename?: "GatsbyCallSite"
  fileName: Scalars["String"]
  functionName?: Maybe<Scalars["String"]>
  lineNumber?: Maybe<Scalars["Int"]>
  columnNumber?: Maybe<Scalars["Int"]>
}

export type GatsbyDependency = {
  __typename?: "GatsbyDependency"
  name: Scalars["String"]
  installedVersion?: Maybe<Scalars["String"]>
}

export type GatsbyPluginVersion = {
  __typename?: "GatsbyPluginVersion"
  id: Scalars["ID"]
  name: Scalars["String"]
  builds?: Maybe<Scalars["String"]>
  incrementalBuilds?: Maybe<Scalars["String"]>
  preview?: Maybe<Scalars["String"]>
}

export type GatsbyPluginVersionUpsertInput = {
  name: Scalars["String"]
  builds?: Maybe<Scalars["String"]>
  preview?: Maybe<Scalars["String"]>
  incrementalBuilds?: Maybe<Scalars["String"]>
}

export type GithubPagination = {
  __typename?: "GithubPagination"
  hasNextPage: Scalars["Boolean"]
  lastId?: Maybe<Scalars["String"]>
}

export type GithubRepoInfo = {
  __typename?: "GithubRepoInfo"
  htmlUrl: Scalars["String"]
  id: Scalars["Int"]
  owner: Scalars["String"]
  name: Scalars["String"]
  fullName: Scalars["String"]
  private: Scalars["Boolean"]
  description: Scalars["String"]
  defaultBranch: Scalars["String"]
}

export type GithubRepoInfoResult = {
  __typename?: "GithubRepoInfoResult"
  exists: Scalars["Boolean"]
  repoInfo?: Maybe<GithubRepoInfo>
}

export enum GlobalErrorType {
  NotGatsbyRepo = "NOT_GATSBY_REPO",
  InvalidGatsbyVersion = "INVALID_GATSBY_VERSION",
  UnkownError = "UNKOWN_ERROR",
  NoOrganizationPermission = "NO_ORGANIZATION_PERMISSION",
  InvitationAccepted = "INVITATION_ACCEPTED",
  InvitationExpired = "INVITATION_EXPIRED",
  BlacklistedPackage = "BLACKLISTED_PACKAGE",
  UpdateGithubPermissions = "UPDATE_GITHUB_PERMISSIONS",
  NeedGithubAppFuturePermissions = "NEED_GITHUB_APP_FUTURE_PERMISSIONS",
  InvalidSitePublicname = "INVALID_SITE_PUBLICNAME",
  InvalidSitePrefix = "INVALID_SITE_PREFIX",
}

export type HostingCertificate = {
  __typename?: "HostingCertificate"
  id: Scalars["String"]
  createdAt: Scalars["DateTime"]
  notAfter: Scalars["DateTime"]
  notBefore: Scalars["DateTime"]
  issuer: Scalars["String"]
  issuedTo: Scalars["String"]
  domains?: Maybe<Array<Maybe<HostingCertificateDomain>>>
  managed: Scalars["Boolean"]
  canDelete: Scalars["Boolean"]
  serialNumber: Scalars["String"]
  errors?: Maybe<Array<Scalars["String"]>>
}

export type HostingCertificateDomain = {
  __typename?: "HostingCertificateDomain"
  id: Scalars["String"]
}

export type HostingDetails = {
  __typename?: "HostingDetails"
  id: Scalars["String"]
  certificates?: Maybe<Array<Maybe<HostingCertificate>>>
  domains?: Maybe<Array<Maybe<HostingDomain>>>
  dns?: Maybe<Array<Maybe<HostingDnsInfo>>>
}

export type HostingDnsInfo = {
  __typename?: "HostingDnsInfo"
  id: Scalars["String"]
  type: DnsType
}

export type HostingDomain = {
  __typename?: "HostingDomain"
  id: Scalars["String"]
  verified: Scalars["Boolean"]
  verificationMessage?: Maybe<Scalars["String"]>
  errorMessage?: Maybe<Scalars["String"]>
  dns?: Maybe<Array<Maybe<HostingDnsInfo>>>
  cloudCdnDefault?: Maybe<Scalars["Boolean"]>
  certificateStatus: CertificateStatus
  primaryDomainId?: Maybe<Scalars["String"]>
}

export type HostingTierMetadata = {
  __typename?: "HostingTierMetadata"
  tier: MachinePricingTier
  hostingPOP?: Maybe<Scalars["String"]>
  hostingBandwidth?: Maybe<Scalars["String"]>
  hostingRequests?: Maybe<Scalars["String"]>
  imageCdnRequests?: Maybe<Scalars["String"]>
  totalSiteRoutes?: Maybe<Scalars["String"]>
  monthlyBuildMinutes?: Maybe<Scalars["String"]>
}

export type ImageCdnEncryption = {
  __typename?: "ImageCdnEncryption"
  imageCdnKey: Scalars["String"]
  imageCdnIv: Scalars["String"]
}

export type InstalledGatsbyAndSourcePluginVersion = {
  __typename?: "InstalledGatsbyAndSourcePluginVersion"
  success?: Maybe<Scalars["Boolean"]>
  status?: Maybe<GatsbySiteModulesStatus>
  gatsbyVersion?: Maybe<Scalars["String"]>
  sourcePluginVersion?: Maybe<Scalars["String"]>
}

export type IntegrationFeatures = {
  __typename?: "IntegrationFeatures"
  envVars?: Maybe<Scalars["Boolean"]>
  webhooks?: Maybe<Scalars["Boolean"]>
  extension?: Maybe<Scalars["Boolean"]>
}

export enum InternationalPopsTier {
  ZoneEuNa = "ZONE_EU_NA",
  ZoneGlobal = "ZONE_GLOBAL",
}

export type Invitation = {
  __typename?: "Invitation"
  id: Scalars["UUID"]
  invitationUserId?: Maybe<Scalars["UUID"]>
  invitationName?: Maybe<Scalars["String"]>
  invitationEmail?: Maybe<Scalars["String"]>
  senderUserId: Scalars["UUID"]
  senderEmail?: Maybe<Scalars["String"]>
  senderName?: Maybe<Scalars["String"]>
  accepted?: Maybe<Scalars["Boolean"]>
  expired?: Maybe<Scalars["Boolean"]>
  sent?: Maybe<Scalars["Boolean"]>
  resourceType?: Maybe<CloudResourceType>
  resourceId: Scalars["UUID"]
  role?: Maybe<CloudRole>
  type?: Maybe<InvitationType>
  resources?: Maybe<Array<Maybe<InvitationResource>>>
  invitationUrl?: Maybe<Scalars["String"]>
}

export type InvitationEmailResourceCreateInput = {
  type?: Maybe<InvitationType>
  resources: Array<InvitationResourceCreateInput>
  email: Scalars["String"]
  name?: Maybe<Scalars["String"]>
  isOwnershipTransfer?: Maybe<Scalars["Boolean"]>
}

export type InvitationListResult = {
  __typename?: "InvitationListResult"
  invitations: Array<Invitation>
  total: Scalars["Int"]
}

export type InvitationResource = {
  __typename?: "InvitationResource"
  resourceType: CloudResourceType
  resourceId: Scalars["UUID"]
  role: CloudRole
  resourceOrganizationName?: Maybe<Scalars["String"]>
}

export type InvitationResourceCreateInput = {
  resourceType: CloudResourceType
  resourceId: Scalars["UUID"]
  role: CloudRole
}

export type InvitationResult = {
  __typename?: "InvitationResult"
  invitation?: Maybe<Invitation>
  validation: MutationResult
}

export enum InvitationType {
  ParentOrganization = "PARENT_ORGANIZATION",
  Organization = "ORGANIZATION",
}

export type K8SResourceRequirement = {
  __typename?: "K8SResourceRequirement"
  cpuLimits: Scalars["String"]
  memoryLimits: Scalars["String"]
  cpuRequests: Scalars["String"]
  memoryRequests: Scalars["String"]
}

export enum LeadSource {
  Hubspot = "HUBSPOT",
  Organic = "ORGANIC",
}

export type Log = {
  __typename?: "Log"
  id?: Maybe<Scalars["UUID"]>
  timestamp?: Maybe<Scalars["DateTime"]>
  message?: Maybe<Scalars["String"]>
  sourceStream?: Maybe<LogSourceStream>
  command?: Maybe<Scalars["String"]>
  invocationId?: Maybe<Scalars["UUID"]>
}

export enum LogCategory {
  User = "USER",
  System = "SYSTEM",
  ThirdParty = "THIRD_PARTY",
}

export type LogDrainIntegration = {
  __typename?: "LogDrainIntegration"
  lastDrainedAt?: Maybe<Scalars["DateTime"]>
  siteId: Scalars["UUID"]
  logDrainProvider: LogDrainProvider
  config: Scalars["JSON"]
  id: Scalars["UUID"]
  error?: Maybe<Scalars["String"]>
}

export enum LogDrainProvider {
  Datadog = "DATADOG",
}

export enum LogErrorType {
  Graphql = "GRAPHQL",
  Config = "CONFIG",
  Webpack = "WEBPACK",
  Plugin = "PLUGIN",
}

export enum LogSourceStream {
  Stderr = "STDERR",
  Stdout = "STDOUT",
}

export enum MachinePricingTier {
  Free = "FREE",
  Standard = "STANDARD",
  Performance = "PERFORMANCE",
  Professional = "PROFESSIONAL",
  Agency = "AGENCY",
  Optimized = "OPTIMIZED",
  Enterprise = "ENTERPRISE",
}

export type MerlinSourceEvent = {
  __typename?: "MerlinSourceEvent"
  id: Scalars["ID"]
  status: MerlinStatus
  createdAt: Scalars["DateTime"]
  startedAt?: Maybe<Scalars["DateTime"]>
  endedAt?: Maybe<Scalars["DateTime"]>
  resourceId: Scalars["UUID"]
  resourceType: MerlinSourceEventResourceType
  cmsVendor: CmsVendor
  isFullSource?: Maybe<Scalars["Boolean"]>
  tagName?: Maybe<Scalars["String"]>
}

export enum MerlinSourceEventResourceType {
  Site = "SITE",
  DataLayer = "DATA_LAYER",
}

export type MerlinSourceEventResults = {
  __typename?: "MerlinSourceEventResults"
  pageInfo?: Maybe<CursorPageInfo>
  merlinSourceEvents?: Maybe<Array<Maybe<MerlinSourceEvent>>>
}

export type MerlinSourceMetadata = {
  __typename?: "MerlinSourceMetadata"
  buildType?: Maybe<BuildType>
  commitSha?: Maybe<Scalars["String"]>
  buildSource?: Maybe<BuildSource>
  pluginName?: Maybe<Scalars["String"]>
  publishStartTime?: Maybe<Scalars["DateTime"]>
}

export type MerlinSourceMetadataInput = {
  buildType?: Maybe<BuildType>
  commitSha?: Maybe<Scalars["String"]>
  buildSource?: Maybe<BuildSource>
  pluginName?: Maybe<Scalars["String"]>
  publishStartTime?: Maybe<Scalars["DateTime"]>
}

export enum MerlinStatus {
  Pending = "PENDING",
  BuildingSchema = "BUILDING_SCHEMA",
  Cancelled = "CANCELLED",
  Success = "SUCCESS",
  Idle = "IDLE",
  InProgress = "IN_PROGRESS",
  Failed = "FAILED",
}

export enum MerlinUpdateType {
  Data = "DATA",
  Source = "SOURCE",
}

export enum MetricUnit {
  Milliseconds = "MILLISECONDS",
  Seconds = "SECONDS",
  Minutes = "MINUTES",
  Count = "COUNT",
  Other = "OTHER",
}

export type MockUserCreateInput = {
  name: Scalars["String"]
  email: Scalars["String"]
}

export type Mutation = {
  __typename?: "Mutation"
  acceptInvitation?: Maybe<MutationResult>
  acceptResourceInvitation?: Maybe<AcceptInvitationResult>
  activateHostingVersion?: Maybe<MutationResult>
  addCloudCdnDomain?: Maybe<MutationResult>
  addHubSpotContactListToBeta?: Maybe<MutationResult>
  adminChangePlan?: Maybe<MutationResult>
  adminChangeRepositoryForSite?: Maybe<Site>
  adminCloneAndCreateSite?: Maybe<MutationResult>
  adminCreateCmsProvider?: Maybe<MutationResult>
  adminCreateCmsProvisioningStarter?: Maybe<MutationResult>
  adminCreateEnterprisePlan?: Maybe<MutationResult>
  adminCreateSsoIntegration?: Maybe<MutationResult>
  adminCreateTrialForOrganization?: Maybe<MutationResult>
  adminDeleteFeatureFlag?: Maybe<MutationResult>
  adminDeleteOrganization?: Maybe<MutationResult>
  adminEndBuild?: Maybe<MutationResult>
  adminGrantPlan?: Maybe<MutationResult>
  adminInitializeUsageLimits?: Maybe<MutationResult>
  adminMigrateSiteCluster?: Maybe<MutationResult>
  adminOverridePlatformResourceLimits?: Maybe<MutationResult>
  adminRebuildSite?: Maybe<RebuildSiteResult>
  adminRemoveCmsProvider?: Maybe<MutationResult>
  adminRemoveCmsProvisioningStarter?: Maybe<MutationResult>
  adminRemoveDependency?: Maybe<MutationResult>
  adminRemoveUser?: Maybe<MutationResult>
  adminRenovateSite?: Maybe<MutationResult>
  adminSetOrganizationActive?: Maybe<MutationResult>
  adminSetOrganizationIdle?: Maybe<MutationResult>
  adminSetOrganizationOverage?: Maybe<MutationResult>
  adminStartPreview?: Maybe<MutationResult>
  adminStopPreview?: Maybe<MutationResult>
  adminSubscriptionExtension?: Maybe<MutationResult>
  adminToggleDependency?: Maybe<MutationResult>
  adminToggleFeatureFlag?: Maybe<MutationResult>
  adminToggleFlag?: Maybe<MutationResult>
  adminToggleUsageCap?: Maybe<MutationResult>
  adminToggleUserBan?: Maybe<MutationResult>
  adminTransferBillingSubscription?: Maybe<MutationResult>
  adminTransferOrganizationOwnership?: Maybe<MutationResult>
  adminTransferSiteOwnership?: Maybe<MutationResult>
  adminUpdateAllPreviewImages?: Maybe<MutationResult>
  adminUpdateCmsExtension?: Maybe<MutationResult>
  adminUpdatePreviewImage?: Maybe<MutationResult>
  adminUpdateSiteResourceLimit?: Maybe<MutationResult>
  adminUpdateUsageLimits?: Maybe<MutationResult>
  adminUpdateUserNickname?: Maybe<MutationResult>
  adminUpsertDependency?: Maybe<MutationResult>
  adminUpsertGatsbyPluginVersion?: Maybe<GatsbyPluginVersion>
  adminUpsertSiteDiagnostics?: Maybe<MutationResult>
  attachReportPluginToSite?: Maybe<MutationResult>
  cancelBuild?: Maybe<MutationResult>
  cancelPlan?: Maybe<MutationResult>
  changePlan?: Maybe<MutationResult>
  connectAzureToSite?: Maybe<MutationResult>
  connectCloudCdnToSite?: Maybe<MutationResult>
  connectFastlyToSite?: Maybe<MutationResult>
  connectGCSToSite?: Maybe<MutationResult>
  connectS3ToSite?: Maybe<MutationResult>
  createGatsbyOrganization?: Maybe<Organization>
  createInvitationForResources: CreateInvitationResult
  createLogDrainIntegration?: Maybe<MutationResult>
  createNetlifySite?: Maybe<NetlifyCreateSiteResult>
  createNowProject?: Maybe<NowCreateProjectResult>
  createProvisionedSite: CreateSiteResult
  createSite: CreateSiteResult
  createSiteFromUrl: CreateSiteFromUrlResult
  createVcsConfiguration?: Maybe<MutationResult>
  deleteCDNFromSiteByVendor?: Maybe<MutationResult>
  deleteContributorFromOrganization?: Maybe<MutationResult>
  deleteContributorFromSite?: Maybe<MutationResult>
  deleteLogDrainIntegration?: Maybe<MutationResult>
  deleteSite?: Maybe<MutationResult>
  deleteVcsConfiguration?: Maybe<MutationResult>
  disconnectCloudCdnToSite?: Maybe<MutationResult>
  disconnectShopifyAppIntegration?: Maybe<MutationResult>
  enableSubscriptionTrial?: Maybe<MutationResult>
  finalizeSiteProvisioning?: Maybe<MutationResult>
  generateProrationAmount?: Maybe<ProrationAmount>
  installContentfulIntegration?: Maybe<MutationResult>
  installCosmicCmsIntegration?: Maybe<MutationResult>
  installDatoCmsIntegration?: Maybe<MutationResult>
  installShopifyCmsIntegration?: Maybe<MutationResult>
  inviteBetaUser?: Maybe<MutationResult>
  inviteContributorsToResource?: Maybe<Array<Maybe<Contributor>>>
  ping: Scalars["String"]
  provisionSetupDataForSite: ProvisionSetupDataForSiteResult
  publishSite?: Maybe<Site>
  purchaseAdditionalFeatures?: Maybe<SubscriptionPlan>
  rebuildSite?: Maybe<RebuildSiteResult>
  redirectDefaultToPrimary?: Maybe<MutationResult>
  removeCloudCdnCertificate?: Maybe<MutationResult>
  removeCloudCdnDomain?: Maybe<MutationResult>
  removeCmsConfigurationForSite?: Maybe<MutationResult>
  removeNotificationIntegration?: Maybe<MutationResult>
  removeReportPluginFromSite?: Maybe<MutationResult>
  requestCloudCdnCertificate?: Maybe<MutationResult>
  requestPlanChange?: Maybe<MutationResult>
  resendInvitation?: Maybe<MutationResult>
  revokeInvitation?: Maybe<MutationResult>
  sendBetaAccessInvitation?: Maybe<MutationResult>
  setCDNConfig?: Maybe<MutationResult>
  setCloudCdnDomainAsPrimary?: Maybe<MutationResult>
  setCosmicCMSWebhooks?: Maybe<MutationResult>
  setOrganizationActive?: Maybe<MutationResult>
  setShopifyAppIntegration?: Maybe<MutationResult>
  setSiteCMSIntegration?: Maybe<MutationResult>
  setSitePreviewProtection?: Maybe<MutationResult>
  setSitePreviewTargets?: Maybe<MutationResult>
  setSitePublishBranch?: Maybe<MutationResult>
  subscribeToPlan?: Maybe<SubscriptionResult>
  toggleBuildChecks?: Maybe<MutationResult>
  toggleBuildFlag?: Maybe<MutationResult>
  toggleBurstModeEnabled?: Maybe<MutationResult>
  toggleGatsbyjsioEnabled?: Maybe<MutationResult>
  toggleImageCdnFlag?: Maybe<MutationResult>
  toggleIncrementalBuildFlag?: Maybe<MutationResult>
  toggleIncrementalDeploysEnabled?: Maybe<MutationResult>
  toggleIncrementalDeploysProductionEnabled?: Maybe<MutationResult>
  toggleManualHostingDeploys?: Maybe<MutationResult>
  toggleMerlinGraphQLApiEnabled?: Maybe<MutationResult>
  toggleMerlinPullRequestsSourcingEnabled?: Maybe<MutationResult>
  toggleMerlinSourcingEnabled?: Maybe<MutationResult>
  togglePreviewBuildFlag?: Maybe<MutationResult>
  toggleSlicesAPIEnabled?: Maybe<MutationResult>
  transferOrganizationOwnership?: Maybe<MutationResult>
  triggerCloudBuilder?: Maybe<MutationResult>
  triggerDeployPreview?: Maybe<MutationResult>
  triggerMerlinSourcing?: Maybe<MutationResult>
  updateContributorRoles: UpdateContributorRolesResult
  updateEnvironmentVariablesForSite?: Maybe<MutationResult>
  updateLogDrainIntegration?: Maybe<MutationResult>
  updateOrganizationName?: Maybe<MutationResult>
  updatePaymentInformation?: Maybe<UpdatePaymentResult>
  updatePreviewTriggerType?: Maybe<MutationResult>
  updateSiteBranch?: Maybe<MutationResult>
  updateUserInformation?: Maybe<MutationResult>
  updateUserWelcomeFields?: Maybe<MutationResult>
  upsertCloudCdnCertificate?: Maybe<MutationResult>
  upsertNotificationIntegration?: Maybe<NotificationIntegration>
  verifyCloudCdnDomain?: Maybe<MutationResult>
  verifyPreviewPassword?: Maybe<MutationResult>
  verifyProductionPassword?: Maybe<MutationResult>
}

export type MutationAcceptInvitationArgs = {
  invitationId: Scalars["UUID"]
}

export type MutationAcceptResourceInvitationArgs = {
  invitationId: Scalars["UUID"]
  organizationId?: Maybe<Scalars["UUID"]>
}

export type MutationActivateHostingVersionArgs = {
  siteId: Scalars["UUID"]
  buildId: Scalars["UUID"]
}

export type MutationAddCloudCdnDomainArgs = {
  domainName: Scalars["String"]
  siteId: Scalars["UUID"]
}

export type MutationAddHubSpotContactListToBetaArgs = {
  listId: Scalars["ID"]
}

export type MutationAdminChangePlanArgs = {
  organizationId: Scalars["UUID"]
  nextPlanId: Scalars["UUID"]
}

export type MutationAdminChangeRepositoryForSiteArgs = {
  siteId: Scalars["UUID"]
  provider: SourceControlProvider
  enterpriseVCSConfigId?: Maybe<Scalars["UUID"]>
  repoFullName: Scalars["String"]
}

export type MutationAdminCloneAndCreateSiteArgs = {
  sourceSiteId: Scalars["UUID"]
}

export type MutationAdminCreateCmsProviderArgs = {
  vendor: Scalars["String"]
  description: Scalars["String"]
  details: Scalars["String"]
  logoUrl: Scalars["String"]
  provisioningEnabled?: Maybe<Scalars["Boolean"]>
  integrationsEnabled?: Maybe<Scalars["Boolean"]>
}

export type MutationAdminCreateCmsProvisioningStarterArgs = {
  vendor: CmsVendor
  type: Scalars["String"]
  description: Scalars["String"]
  projectSlug: Scalars["String"]
  starterImageUrl: Scalars["String"]
  available?: Maybe<Scalars["Boolean"]>
}

export type MutationAdminCreateEnterprisePlanArgs = {
  plan?: Maybe<SubscriptionPlanCreateInput>
}

export type MutationAdminCreateSsoIntegrationArgs = {
  workspaceId: Scalars["UUID"]
  ssoName?: Maybe<Scalars["String"]>
  domains: Array<Scalars["String"]>
}

export type MutationAdminCreateTrialForOrganizationArgs = {
  organizationId: Scalars["UUID"]
  planName: Scalars["String"]
}

export type MutationAdminDeleteFeatureFlagArgs = {
  name: Scalars["String"]
  resourceId?: Maybe<Scalars["UUID"]>
}

export type MutationAdminDeleteOrganizationArgs = {
  organizationId: Scalars["UUID"]
}

export type MutationAdminEndBuildArgs = {
  id: Scalars["UUID"]
  siteId: Scalars["UUID"]
}

export type MutationAdminGrantPlanArgs = {
  organizationId: Scalars["UUID"]
  adminPlanType: AdminPlanType
}

export type MutationAdminInitializeUsageLimitsArgs = {
  organizationId: Scalars["UUID"]
}

export type MutationAdminMigrateSiteClusterArgs = {
  id: Scalars["UUID"]
  clusterName: Scalars["String"]
}

export type MutationAdminOverridePlatformResourceLimitsArgs = {
  workspaceId: Scalars["UUID"]
  siteId: Scalars["UUID"]
  limits: PlatformResourceLimitUpdateInput
}

export type MutationAdminRebuildSiteArgs = {
  id: Scalars["UUID"]
}

export type MutationAdminRemoveCmsProviderArgs = {
  id: Scalars["UUID"]
}

export type MutationAdminRemoveCmsProvisioningStarterArgs = {
  id: Scalars["UUID"]
}

export type MutationAdminRemoveDependencyArgs = {
  dependencyId: Scalars["ID"]
}

export type MutationAdminRemoveUserArgs = {
  userId: Scalars["UUID"]
}

export type MutationAdminRenovateSiteArgs = {
  siteId: Scalars["UUID"]
}

export type MutationAdminSetOrganizationActiveArgs = {
  id: Scalars["UUID"]
}

export type MutationAdminSetOrganizationIdleArgs = {
  id: Scalars["UUID"]
}

export type MutationAdminSetOrganizationOverageArgs = {
  id: Scalars["UUID"]
}

export type MutationAdminStartPreviewArgs = {
  siteId: Scalars["UUID"]
}

export type MutationAdminStopPreviewArgs = {
  siteId: Scalars["UUID"]
}

export type MutationAdminSubscriptionExtensionArgs = {
  organizationId: Scalars["UUID"]
  days?: Maybe<Scalars["Int"]>
}

export type MutationAdminToggleDependencyArgs = {
  dependencyId: Scalars["ID"]
}

export type MutationAdminToggleFeatureFlagArgs = {
  name: Scalars["String"]
  resourceId?: Maybe<Scalars["UUID"]>
  enabled: Scalars["Boolean"]
}

export type MutationAdminToggleFlagArgs = {
  name: Scalars["String"]
  resourceId: Scalars["UUID"]
  enabled: Scalars["Boolean"]
}

export type MutationAdminToggleUsageCapArgs = {
  organizationId: Scalars["UUID"]
  actionType: UsageActionType
  enforceCap: Scalars["Boolean"]
}

export type MutationAdminToggleUserBanArgs = {
  userId: Scalars["UUID"]
}

export type MutationAdminTransferBillingSubscriptionArgs = {
  sourceOrganizationId: Scalars["UUID"]
  targetOrganizationId: Scalars["UUID"]
}

export type MutationAdminTransferOrganizationOwnershipArgs = {
  organizationId: Scalars["UUID"]
  targetUserId: Scalars["UUID"]
}

export type MutationAdminTransferSiteOwnershipArgs = {
  siteId: Scalars["UUID"]
  targetUserId: Scalars["UUID"]
}

export type MutationAdminUpdateCmsExtensionArgs = {
  vendor: CmsVendor
}

export type MutationAdminUpdatePreviewImageArgs = {
  siteId: Scalars["UUID"]
  imageTag?: Maybe<Scalars["String"]>
}

export type MutationAdminUpdateSiteResourceLimitArgs = {
  siteId: Scalars["UUID"]
  limits: SiteResourceLimitsUpdateInput
}

export type MutationAdminUpdateUsageLimitsArgs = {
  usageLimitId: Scalars["ID"]
  limitInterval: UsageInterval
  usageInterval: UsageInterval
  limit: Scalars["Int"]
}

export type MutationAdminUpdateUserNicknameArgs = {
  id: Scalars["UUID"]
  nickname: Scalars["String"]
}

export type MutationAdminUpsertDependencyArgs = {
  dependency: SiteDependencyUpsertInput
}

export type MutationAdminUpsertGatsbyPluginVersionArgs = {
  plugin?: Maybe<GatsbyPluginVersionUpsertInput>
}

export type MutationAdminUpsertSiteDiagnosticsArgs = {
  dependencyId: Scalars["ID"]
  diagnostics: Array<DependencyDiagnosticInput>
}

export type MutationAttachReportPluginToSiteArgs = {
  siteId: Scalars["UUID"]
  vendor: ReportPluginVendor
}

export type MutationCancelBuildArgs = {
  buildId: Scalars["UUID"]
  siteId: Scalars["UUID"]
  runnerType: BuildRunnerType
}

export type MutationCancelPlanArgs = {
  organizationId: Scalars["UUID"]
}

export type MutationChangePlanArgs = {
  organizationId: Scalars["UUID"]
  nextPlanId: Scalars["UUID"]
}

export type MutationConnectAzureToSiteArgs = {
  siteId: Scalars["UUID"]
  config: AzureConnectionInput
}

export type MutationConnectCloudCdnToSiteArgs = {
  siteId: Scalars["UUID"]
}

export type MutationConnectFastlyToSiteArgs = {
  siteId: Scalars["UUID"]
  config: FastlyConnectionInput
}

export type MutationConnectGcsToSiteArgs = {
  siteId: Scalars["UUID"]
  config: GcsConnectionInput
}

export type MutationConnectS3ToSiteArgs = {
  siteId: Scalars["UUID"]
  config: S3ConnectionInput
}

export type MutationCreateGatsbyOrganizationArgs = {
  name: Scalars["String"]
  avatarUrl?: Maybe<Scalars["String"]>
  subscription?: Maybe<SubscriptionBootstrapInput>
}

export type MutationCreateInvitationForResourcesArgs = {
  invitations: Array<InvitationEmailResourceCreateInput>
}

export type MutationCreateLogDrainIntegrationArgs = {
  config: Scalars["JSON"]
  siteId: Scalars["UUID"]
  logDrainProvider: LogDrainProvider
}

export type MutationCreateNetlifySiteArgs = {
  serviceName: Scalars["String"]
  siteId: Scalars["UUID"]
  accountName: Scalars["String"]
}

export type MutationCreateNowProjectArgs = {
  serviceName: Scalars["String"]
  siteId: Scalars["UUID"]
  accountName?: Maybe<Scalars["String"]>
}

export type MutationCreateProvisionedSiteArgs = {
  selectedInstallationId: Scalars["String"]
  organizationId?: Maybe<Scalars["UUID"]>
  provider?: Maybe<SourceControlProvider>
  enterpriseVCSConfigId?: Maybe<Scalars["UUID"]>
  projectName: Scalars["String"]
  vendor: CmsVendor
  templateId: Scalars["String"]
}

export type MutationCreateSiteArgs = {
  organizationId?: Maybe<Scalars["UUID"]>
  provider?: Maybe<SourceControlProvider>
  selectedInstallationId: Scalars["String"]
  enterpriseVCSConfigId?: Maybe<Scalars["UUID"]>
  nameWithOwner: Scalars["String"]
  directoryPath?: Maybe<Scalars["String"]>
  branch?: Maybe<Scalars["String"]>
  publicName?: Maybe<Scalars["String"]>
}

export type MutationCreateSiteFromUrlArgs = {
  workspaceId: Scalars["UUID"]
  selectedInstallationId: Scalars["String"]
  repoUrl: Scalars["String"]
  targetRepoName: Scalars["String"]
}

export type MutationCreateVcsConfigurationArgs = {
  organizationId: Scalars["UUID"]
  source?: Maybe<SourceControlProvider>
  vcsConfigSettings?: Maybe<Scalars["JSON"]>
  vcsConfig?: Maybe<VcsConfigSettings>
}

export type MutationDeleteCdnFromSiteByVendorArgs = {
  siteId: Scalars["UUID"]
  vendor: CdnVendor
}

export type MutationDeleteContributorFromOrganizationArgs = {
  organizationId: Scalars["UUID"]
  contributorId: Scalars["UUID"]
}

export type MutationDeleteContributorFromSiteArgs = {
  siteId: Scalars["UUID"]
  contributorId: Scalars["UUID"]
}

export type MutationDeleteLogDrainIntegrationArgs = {
  siteId: Scalars["UUID"]
  integrationId: Scalars["UUID"]
}

export type MutationDeleteSiteArgs = {
  id: Scalars["UUID"]
}

export type MutationDeleteVcsConfigurationArgs = {
  id: Scalars["UUID"]
}

export type MutationDisconnectCloudCdnToSiteArgs = {
  siteId: Scalars["UUID"]
}

export type MutationDisconnectShopifyAppIntegrationArgs = {
  shopName: Scalars["String"]
  sessionToken: Scalars["String"]
}

export type MutationEnableSubscriptionTrialArgs = {
  organizationId: Scalars["UUID"]
  planName: Scalars["String"]
}

export type MutationFinalizeSiteProvisioningArgs = {
  siteId: Scalars["UUID"]
  cmsTemplateId: Scalars["String"]
}

export type MutationGenerateProrationAmountArgs = {
  additionalFeatures?: Maybe<Array<Maybe<AdditionalFeaturesInput>>>
  workspaceId: Scalars["UUID"]
}

export type MutationInstallContentfulIntegrationArgs = {
  siteId: Scalars["UUID"]
  integrationToken: Scalars["String"]
  provision?: Maybe<Scalars["Boolean"]>
}

export type MutationInstallCosmicCmsIntegrationArgs = {
  siteId: Scalars["UUID"]
  authToken: Scalars["String"]
  provision?: Maybe<Scalars["Boolean"]>
}

export type MutationInstallDatoCmsIntegrationArgs = {
  siteId: Scalars["UUID"]
  integrationToken: Scalars["String"]
}

export type MutationInstallShopifyCmsIntegrationArgs = {
  siteId: Scalars["UUID"]
  password: Scalars["String"]
  provision?: Maybe<Scalars["Boolean"]>
}

export type MutationInviteBetaUserArgs = {
  user: MockUserCreateInput
}

export type MutationInviteContributorsToResourceArgs = {
  id: Scalars["UUID"]
  emails: Array<Scalars["String"]>
  resourceType: CloudResourceType
}

export type MutationProvisionSetupDataForSiteArgs = {
  siteId: Scalars["UUID"]
  workspaceId: Scalars["UUID"]
}

export type MutationPublishSiteArgs = {
  id: Scalars["UUID"]
  environmentVariables: Array<TagInput>
}

export type MutationPurchaseAdditionalFeaturesArgs = {
  prorationDate: Scalars["DateTime"]
  additionalFeatures?: Maybe<Array<Maybe<AdditionalFeaturesInput>>>
  workspaceId: Scalars["UUID"]
}

export type MutationRebuildSiteArgs = {
  id: Scalars["UUID"]
  deleteCache?: Maybe<Scalars["Boolean"]>
}

export type MutationRedirectDefaultToPrimaryArgs = {
  siteId: Scalars["UUID"]
  domainName?: Maybe<Scalars["String"]>
}

export type MutationRemoveCloudCdnCertificateArgs = {
  id: Scalars["String"]
  siteId: Scalars["UUID"]
}

export type MutationRemoveCloudCdnDomainArgs = {
  domainName: Scalars["String"]
  siteId: Scalars["UUID"]
}

export type MutationRemoveCmsConfigurationForSiteArgs = {
  siteId: Scalars["UUID"]
  vendor?: Maybe<CmsVendor>
}

export type MutationRemoveNotificationIntegrationArgs = {
  integrationId: Scalars["ID"]
}

export type MutationRemoveReportPluginFromSiteArgs = {
  siteId: Scalars["UUID"]
  vendor: ReportPluginVendor
}

export type MutationRequestCloudCdnCertificateArgs = {
  domainName: Scalars["String"]
  siteId: Scalars["UUID"]
}

export type MutationRequestPlanChangeArgs = {
  request: RequestPlanChangeInfoInput
}

export type MutationResendInvitationArgs = {
  id: Scalars["UUID"]
  isOwnershipTransfer?: Maybe<Scalars["Boolean"]>
}

export type MutationRevokeInvitationArgs = {
  id: Scalars["UUID"]
}

export type MutationSendBetaAccessInvitationArgs = {
  id: Scalars["UUID"]
  email: Scalars["String"]
  name: Scalars["String"]
}

export type MutationSetCdnConfigArgs = {
  siteId: Scalars["UUID"]
  serviceId: Scalars["String"]
  serviceName: Scalars["String"]
  accountName?: Maybe<Scalars["String"]>
  vendor: CdnVendor
}

export type MutationSetCloudCdnDomainAsPrimaryArgs = {
  domainName: Scalars["String"]
  siteId: Scalars["UUID"]
}

export type MutationSetCosmicCmsWebhooksArgs = {
  siteId: Scalars["UUID"]
}

export type MutationSetOrganizationActiveArgs = {
  id: Scalars["UUID"]
}

export type MutationSetShopifyAppIntegrationArgs = {
  siteId: Scalars["UUID"]
  shopifyAppToken: Scalars["String"]
  shopifyStoreFrontToken?: Maybe<Scalars["String"]>
  shopName: Scalars["String"]
}

export type MutationSetSiteCmsIntegrationArgs = {
  siteId: Scalars["UUID"]
  vendor: CmsVendor
  config: Scalars["JSON"]
}

export type MutationSetSitePreviewProtectionArgs = {
  id: Scalars["UUID"]
  type: PreviewProtectionType
  password?: Maybe<Scalars["String"]>
}

export type MutationSetSitePreviewTargetsArgs = {
  branch: Scalars["String"]
  siteId: Scalars["UUID"]
  directoryPath: Scalars["String"]
  description?: Maybe<Scalars["String"]>
  publicName?: Maybe<Scalars["String"]>
  sitePrefix?: Maybe<Scalars["String"]>
}

export type MutationSetSitePublishBranchArgs = {
  branch: Scalars["String"]
  siteId: Scalars["UUID"]
}

export type MutationSubscribeToPlanArgs = {
  input?: Maybe<SubscriptionCreateInput>
}

export type MutationToggleBuildChecksArgs = {
  siteId: Scalars["UUID"]
}

export type MutationToggleBuildFlagArgs = {
  siteId: Scalars["UUID"]
  userId: Scalars["UUID"]
}

export type MutationToggleBurstModeEnabledArgs = {
  siteId: Scalars["UUID"]
}

export type MutationToggleGatsbyjsioEnabledArgs = {
  siteId: Scalars["UUID"]
}

export type MutationToggleImageCdnFlagArgs = {
  siteId: Scalars["UUID"]
}

export type MutationToggleIncrementalBuildFlagArgs = {
  siteId: Scalars["UUID"]
  userId?: Maybe<Scalars["UUID"]>
}

export type MutationToggleIncrementalDeploysEnabledArgs = {
  siteId: Scalars["UUID"]
}

export type MutationToggleIncrementalDeploysProductionEnabledArgs = {
  siteId: Scalars["UUID"]
}

export type MutationToggleManualHostingDeploysArgs = {
  siteId: Scalars["UUID"]
}

export type MutationToggleMerlinGraphQlApiEnabledArgs = {
  siteId: Scalars["UUID"]
}

export type MutationToggleMerlinPullRequestsSourcingEnabledArgs = {
  siteId: Scalars["UUID"]
}

export type MutationToggleMerlinSourcingEnabledArgs = {
  siteId: Scalars["UUID"]
}

export type MutationTogglePreviewBuildFlagArgs = {
  siteId: Scalars["UUID"]
  userId: Scalars["UUID"]
}

export type MutationToggleSlicesApiEnabledArgs = {
  siteId: Scalars["UUID"]
}

export type MutationTransferOrganizationOwnershipArgs = {
  organizationId: Scalars["UUID"]
  targetUserId: Scalars["UUID"]
}

export type MutationTriggerCloudBuilderArgs = {
  siteId: Scalars["UUID"]
  branch?: Maybe<Scalars["String"]>
  deleteCache?: Maybe<Scalars["Boolean"]>
}

export type MutationTriggerDeployPreviewArgs = {
  siteId: Scalars["UUID"]
  pullRequestId: Scalars["UUID"]
  deleteCache?: Maybe<Scalars["Boolean"]>
}

export type MutationTriggerMerlinSourcingArgs = {
  siteId: Scalars["UUID"]
  deleteCache?: Maybe<Scalars["Boolean"]>
}

export type MutationUpdateContributorRolesArgs = {
  contributorId: Scalars["UUID"]
  organizationId: Scalars["UUID"]
  resources: Array<UpdateContributorRolesInput>
}

export type MutationUpdateEnvironmentVariablesForSiteArgs = {
  id: Scalars["UUID"]
  environmentVariables: Array<TagInput>
  runnerType?: Maybe<BuildRunnerType>
}

export type MutationUpdateLogDrainIntegrationArgs = {
  siteId: Scalars["UUID"]
  integrationId: Scalars["UUID"]
  config: Scalars["JSON"]
}

export type MutationUpdateOrganizationNameArgs = {
  name: Scalars["String"]
  organizationId: Scalars["UUID"]
}

export type MutationUpdatePaymentInformationArgs = {
  organizationId: Scalars["UUID"]
  token: Scalars["String"]
  customerName: Scalars["String"]
  billingEmail?: Maybe<Scalars["String"]>
}

export type MutationUpdatePreviewTriggerTypeArgs = {
  siteId: Scalars["UUID"]
  triggerType?: Maybe<PreviewTriggerType>
}

export type MutationUpdateSiteBranchArgs = {
  id: Scalars["UUID"]
  branchName: Scalars["String"]
}

export type MutationUpdateUserInformationArgs = {
  user: UserInfoInput
}

export type MutationUpdateUserWelcomeFieldsArgs = {
  user: UserWelcomeInput
}

export type MutationUpsertCloudCdnCertificateArgs = {
  siteId: Scalars["UUID"]
  tlsKey: Scalars["String"]
  tlsCert: Scalars["String"]
  tlsIntermediateCerts?: Maybe<Scalars["String"]>
}

export type MutationUpsertNotificationIntegrationArgs = {
  integration: NotificationUpsertInput
}

export type MutationVerifyCloudCdnDomainArgs = {
  domainName: Scalars["String"]
  siteId: Scalars["UUID"]
}

export type MutationVerifyPreviewPasswordArgs = {
  hostname: Scalars["String"]
  password: Scalars["String"]
}

export type MutationVerifyProductionPasswordArgs = {
  hostname: Scalars["String"]
  password: Scalars["String"]
}

export type MutationResult = {
  __typename?: "MutationResult"
  success: Scalars["Boolean"]
  message?: Maybe<Scalars["String"]>
  errorType?: Maybe<GlobalErrorType>
}

export type NetlifyAccount = {
  __typename?: "NetlifyAccount"
  id: Scalars["ID"]
  name: Scalars["String"]
  slug: Scalars["String"]
}

export type NetlifyCreateSiteResult = {
  __typename?: "NetlifyCreateSiteResult"
  netlifySite?: Maybe<NetlifySite>
  validation?: Maybe<MutationResult>
}

export type NetlifyResults = {
  __typename?: "NetlifyResults"
  accountName?: Maybe<Scalars["String"]>
  sites?: Maybe<Array<Maybe<NetlifySite>>>
}

export type NetlifySite = {
  __typename?: "NetlifySite"
  id: Scalars["ID"]
  name: Scalars["String"]
  customDomain?: Maybe<Scalars["String"]>
  connected?: Maybe<Scalars["Boolean"]>
  accountName: Scalars["String"]
}

export enum NotificationEventType {
  PreviewSucceeded = "PREVIEW_SUCCEEDED",
  PreviewFailed = "PREVIEW_FAILED",
  BuildSucceeded = "BUILD_SUCCEEDED",
  BuildFailed = "BUILD_FAILED",
  DeploySucceeded = "DEPLOY_SUCCEEDED",
  DeployFailed = "DEPLOY_FAILED",
  BuildTimeout = "BUILD_TIMEOUT",
  PreviewTimeout = "PREVIEW_TIMEOUT",
}

export type NotificationIntegration = {
  __typename?: "NotificationIntegration"
  id: Scalars["ID"]
  resourceId?: Maybe<Scalars["UUID"]>
  resourceType: CloudResourceType
  transport: NotificationTransport
  event: NotificationEventType
  config?: Maybe<Scalars["JSON"]>
}

export type NotificationQueuePayloadInput = {
  body?: Maybe<Scalars["String"]>
  buildId: Scalars["UUID"]
  workspaceName: Scalars["String"]
  siteName: Scalars["String"]
  cdnVendor?: Maybe<CdnVendor>
  deployPreviewUrl?: Maybe<Scalars["String"]>
  logsUrl?: Maybe<Scalars["String"]>
  duration?: Maybe<Scalars["String"]>
  errorLogs?: Maybe<Array<Maybe<Scalars["String"]>>>
  lighthouseReportUrl?: Maybe<Scalars["String"]>
  metrics?: Maybe<Array<Maybe<TagInput>>>
}

export enum NotificationTransport {
  OutgoingWebhook = "OUTGOING_WEBHOOK",
  SlackWebhook = "SLACK_WEBHOOK",
  PullRequestComment = "PULL_REQUEST_COMMENT",
}

export type NotificationUpsertInput = {
  id?: Maybe<Scalars["ID"]>
  resourceId: Scalars["UUID"]
  resourceType: CloudResourceType
  transport: NotificationTransport
  event: NotificationEventType
  config?: Maybe<Scalars["JSON"]>
}

export type NowCreateProjectResult = {
  __typename?: "NowCreateProjectResult"
  nowProject?: Maybe<NowProject>
  validation?: Maybe<MutationResult>
}

export type NowProject = {
  __typename?: "NowProject"
  id: Scalars["ID"]
  name: Scalars["String"]
}

export type NowTeam = {
  __typename?: "NowTeam"
  id: Scalars["ID"]
  name: Scalars["String"]
  slug: Scalars["String"]
}

export type OrgRepositoryResult = {
  __typename?: "OrgRepositoryResult"
  pageInfo?: Maybe<CursorPageInfo>
  repos?: Maybe<Array<Maybe<SourceControlRepository>>>
}

export type Organization = {
  __typename?: "Organization"
  id: Scalars["UUID"]
  name: Scalars["String"]
  status?: Maybe<OrganizationStatus>
  avatarUrl?: Maybe<Scalars["String"]>
  source?: Maybe<SourceControlProvider>
  sourceId?: Maybe<Scalars["Int"]>
  githubSourceToken?: Maybe<Scalars["Int"]>
  createdAt: Scalars["DateTime"]
  updatedAt: Scalars["DateTime"]
  sites?: Maybe<Array<Maybe<Site>>>
  siteCount?: Maybe<Scalars["Int"]>
  repositoriesPaged?: Maybe<OrgRepositoryResult>
  repositories?: Maybe<Array<Maybe<SourceControlRepository>>>
  billing?: Maybe<BillingInformation>
  permissions?: Maybe<PermissionsDigest>
  rteSummary?: Maybe<RealTimeEditSummary>
  userId?: Maybe<Scalars["UUID"]>
  enforceCap?: Maybe<Scalars["Boolean"]>
}

export type OrganizationRepositoriesPagedArgs = {
  searchText?: Maybe<Scalars["String"]>
  nextCursor?: Maybe<Scalars["String"]>
  limit?: Maybe<Scalars["Int"]>
}

export type OrganizationPermissionsArgs = {
  viewerUserId?: Maybe<Scalars["UUID"]>
}

export enum OrganizationStatus {
  Active = "ACTIVE",
  Idle = "IDLE",
  Overage = "OVERAGE",
}

export type Pagination = {
  limit: Scalars["Int"]
  offset?: Maybe<Scalars["Int"]>
}

export type PaymentError = {
  __typename?: "PaymentError"
  errorType?: Maybe<Scalars["String"]>
  code?: Maybe<Scalars["String"]>
  message?: Maybe<Scalars["String"]>
  declineCode?: Maybe<Scalars["String"]>
}

export type PermissionedUser = {
  __typename?: "PermissionedUser"
  id: Scalars["UUID"]
  userId: Scalars["UUID"]
  resourceId: Scalars["UUID"]
  role: CloudRole
}

export type PermissionedUsersResult = {
  __typename?: "PermissionedUsersResult"
  count?: Maybe<Scalars["Int"]>
  users?: Maybe<Array<Maybe<PermissionedUser>>>
}

export type PermissionsDigest = {
  __typename?: "PermissionsDigest"
  id?: Maybe<Scalars["UUID"]>
  role?: Maybe<CloudRole>
  resourceId?: Maybe<Scalars["UUID"]>
  sites?: Maybe<ResourcePermissionMap>
  contributor?: Maybe<ContributorPermissionMap>
  organization?: Maybe<ResourcePermissionMap>
  billing?: Maybe<ResourcePermissionMap>
}

export type PermissionsStats = {
  __typename?: "PermissionsStats"
  totalSitesCount?: Maybe<Scalars["Int"]>
  totalSitesOwnedCount?: Maybe<Scalars["Int"]>
  totalOrganizationsCount?: Maybe<Scalars["Int"]>
  totalOrganizationsOwnedCount?: Maybe<Scalars["Int"]>
}

export enum PlanChangeRequest {
  Free = "FREE",
  Business = "BUSINESS",
  Professional = "PROFESSIONAL",
  Enterprise = "ENTERPRISE",
  Agency = "AGENCY",
  Individual = "INDIVIDUAL",
  Team = "TEAM",
  Performance = "PERFORMANCE",
  Standard = "STANDARD",
}

export type PlatformLimitSummary = {
  __typename?: "PlatformLimitSummary"
  id: Scalars["ID"]
  name: Scalars["String"]
  formattedLimit?: Maybe<Scalars["String"]>
  limit: Scalars["Int"]
  workspace: PlatformUsage
  site?: Maybe<PlatformUsage>
  overage: Scalars["Boolean"]
  overageCount: Scalars["Float"]
  formattedOverageCount?: Maybe<Scalars["String"]>
  billingPeriodStart?: Maybe<Scalars["DateTime"]>
  billingPeriodEnd?: Maybe<Scalars["DateTime"]>
  updatedAt: Scalars["DateTime"]
}

export type PlatformLimitSummarySiteArgs = {
  id: Scalars["UUID"]
}

export type PlatformLimitSummaryForWorkspace = {
  __typename?: "PlatformLimitSummaryForWorkspace"
  workspaceId: Scalars["UUID"]
  platformLimitSummaries?: Maybe<Array<Maybe<PlatformLimitSummary>>>
}

export enum PlatformLimitSummaryName {
  Bandwidth = "BANDWIDTH",
  Requests = "REQUESTS",
  Invocations = "INVOCATIONS",
  Sites = "SITES",
  Users = "USERS",
  CustomDomains = "CUSTOM_DOMAINS",
  HostingIntegrations = "HOSTING_INTEGRATIONS",
  MonthlyBuilds = "MONTHLY_BUILDS",
  ImageCdnRequests = "IMAGE_CDN_REQUESTS",
  TotalSiteRoutes = "TOTAL_SITE_ROUTES",
  MonthlyBuildMinutes = "MONTHLY_BUILD_MINUTES",
  ValhallaApiBandwidth = "VALHALLA_API_BANDWIDTH",
}

export type PlatformResourceLimitUpdateInput = {
  cpuLimits: Scalars["String"]
  cpuRequests: Scalars["String"]
  memoryLimits: Scalars["String"]
  memoryRequests: Scalars["String"]
}

export type PlatformResourceLimits = {
  __typename?: "PlatformResourceLimits"
  id: Scalars["ID"]
  workspaceId: Scalars["UUID"]
  siteId?: Maybe<Scalars["UUID"]>
  cpuLimits: Scalars["String"]
  memoryLimits: Scalars["String"]
  cpuRequests: Scalars["String"]
  memoryRequests: Scalars["String"]
  updatedAt?: Maybe<Scalars["DateTime"]>
}

export type PlatformUsage = {
  __typename?: "PlatformUsage"
  resourceId: Scalars["UUID"]
  resourceType: PlatformUsageResourceType
  count: Scalars["Float"]
  formattedCount?: Maybe<Scalars["String"]>
  percentageOfLimit: Scalars["Int"]
}

export enum PlatformUsageResourceType {
  Workspace = "WORKSPACE",
  Site = "SITE",
}

export type PreviewManifest = {
  __typename?: "PreviewManifest"
  page?: Maybe<PreviewManifestPage>
  buildId: Scalars["UUID"]
}

export type PreviewManifestBuildMeta = {
  __typename?: "PreviewManifestBuildMeta"
  status: BuildStatus
  errors?: Maybe<Array<Maybe<StructuredLog>>>
}

export type PreviewManifestInfo = {
  __typename?: "PreviewManifestInfo"
  manifest?: Maybe<PreviewManifest>
  buildMeta?: Maybe<PreviewManifestBuildMeta>
}

export type PreviewManifestPage = {
  __typename?: "PreviewManifestPage"
  path?: Maybe<Scalars["String"]>
  foundPageBy?: Maybe<Scalars["String"]>
}

export enum PreviewProtectionType {
  Password = "PASSWORD",
  Public = "PUBLIC",
  CloudAuth = "CLOUD_AUTH",
  IpRanges = "IP_RANGES",
}

export enum PreviewStatus {
  Unauthorized = "UNAUTHORIZED",
  Ready = "READY",
  Pending = "PENDING",
  Building = "BUILDING",
  Stopped = "STOPPED",
  Rebuilding = "REBUILDING",
  BuildError = "BUILD_ERROR",
  SystemError = "SYSTEM_ERROR",
}

export enum PreviewTriggerType {
  Automatic = "AUTOMATIC",
  Manual = "MANUAL",
}

export type ProjectStarterTemplate = {
  __typename?: "ProjectStarterTemplate"
  id: Scalars["String"]
  name: Scalars["String"]
  description: Scalars["String"]
  available: Scalars["Boolean"]
}

export type ProrationAmount = {
  __typename?: "ProrationAmount"
  nextPeriodAmount?: Maybe<Scalars["Int"]>
  formattedNextPeriodAmount?: Maybe<Scalars["USCurrency"]>
  amount?: Maybe<Scalars["Int"]>
  formattedAmount?: Maybe<Scalars["USCurrency"]>
  prorationDate?: Maybe<Scalars["DateTime"]>
}

export type ProvisionSetupDataForSiteResult = {
  __typename?: "ProvisionSetupDataForSiteResult"
  siteProvisionJob?: Maybe<SiteProvisionJob>
  validation?: Maybe<MutationResult>
}

export type PublicEnterpriseVcsConfig = {
  __typename?: "PublicEnterpriseVcsConfig"
  id: Scalars["UUID"]
  instanceUrl: Scalars["String"]
  name: Scalars["String"]
  source: SourceControlProvider
  status?: Maybe<Scalars["String"]>
  appSlug?: Maybe<Scalars["String"]>
}

export type PullRequest = {
  __typename?: "PullRequest"
  id: Scalars["UUID"]
  siteId: Scalars["UUID"]
  number: Scalars["Int"]
  title: Scalars["String"]
  latestBuild?: Maybe<Build>
  stableBuildURL?: Maybe<Scalars["String"]>
  urlComponent?: Maybe<Scalars["String"]>
}

export type PullRequestInput = {
  title: Scalars["String"]
  number: Scalars["Int"]
  searchText?: Maybe<Scalars["String"]>
  status?: Maybe<PullRequestStatus>
}

export type PullRequestResults = {
  __typename?: "PullRequestResults"
  pageInfo?: Maybe<CursorPageInfo>
  pullRequests?: Maybe<Array<Maybe<PullRequest>>>
}

export enum PullRequestStatus {
  Open = "OPEN",
  Merged = "MERGED",
  Closed = "CLOSED",
}

export type Query = {
  __typename?: "Query"
  activeAndStaleBuilds?: Maybe<ActiveStaleBuildsResult>
  activeBuildBranches?: Maybe<Array<Maybe<Scalars["String"]>>>
  activeCmsIntegrationForSite?: Maybe<CmsIntegration>
  activeCmsIntegrationsForSite?: Maybe<Array<Maybe<CmsIntegration>>>
  adminActiveCmsIntegrationsForSite?: Maybe<Array<Maybe<CmsIntegration>>>
  adminAvailableCmsExtensions: Array<Scalars["String"]>
  adminAvailableCmsProvisioningExtensions: Array<Scalars["String"]>
  adminAvailableCmsStarters?: Maybe<Array<Maybe<CmsProvisioningStarter>>>
  adminAvailableCmsVendors?: Maybe<Array<Maybe<CmsProvider>>>
  adminAvailableSubscriptionPlans?: Maybe<Array<Maybe<SubscriptionPlan>>>
  adminAvailableUpgradesForSite?: Maybe<Array<Maybe<SiteDependency>>>
  adminBuildsBySiteId?: Maybe<BuildResults>
  adminContributorsByOrganization?: Maybe<Array<Maybe<Contributor>>>
  adminContributorsBySite?: Maybe<Array<Maybe<Contributor>>>
  adminDependencyByName?: Maybe<SiteDependency>
  adminEnterprisePlans?: Maybe<Array<Maybe<SubscriptionPlan>>>
  adminGatsbyDependenciesForSite?: Maybe<Array<Maybe<GatsbyDependency>>>
  adminGatsbyPluginVersions?: Maybe<Array<Maybe<GatsbyPluginVersion>>>
  adminGithubInstallationRepositories?: Maybe<Array<Maybe<Repository>>>
  adminGlobalCloudFlags: Array<Maybe<CloudFlag>>
  adminIsUsageCapEnforced?: Maybe<Scalars["Boolean"]>
  adminLoginUrl?: Maybe<Scalars["String"]>
  adminLogsForBuild?: Maybe<Array<Maybe<Log>>>
  adminOrganizationById?: Maybe<Organization>
  adminOrganizationGithubInstallationRepositories?: Maybe<
    Array<Maybe<Repository>>
  >
  adminOrganizationHasActiveGithubInstallation?: Maybe<Scalars["Boolean"]>
  adminOrganizationSearch?: Maybe<Array<Maybe<Organization>>>
  adminOrganizationsByUserId?: Maybe<Array<Maybe<Organization>>>
  adminPlatformLimitSummaries?: Maybe<Array<Maybe<PlatformLimitSummary>>>
  adminPlatformResourceLimits?: Maybe<PlatformResourceLimits>
  adminRecommendedDependencies?: Maybe<SiteDependencyResult>
  adminRepositoryHasSite?: Maybe<Scalars["Boolean"]>
  adminResourceFlags: Array<Maybe<ResourceFlag>>
  adminSSOIntegrationByWorkspaceId?: Maybe<SsoIntegration>
  adminSiteById?: Maybe<Site>
  adminSiteLastCommitDate?: Maybe<Scalars["DateTime"]>
  adminSiteResourceLimit?: Maybe<SiteResourceLimit>
  adminSiteSearch?: Maybe<Array<Maybe<Site>>>
  adminSitesByOrganization?: Maybe<Array<Maybe<Site>>>
  adminSitesByUserId?: Maybe<Array<Maybe<Site>>>
  adminSsoIntegrationAdminUrl?: Maybe<Scalars["String"]>
  adminUserSearchByText: Array<Maybe<User>>
  allSitesBeingTransferredForUser?: Maybe<Array<Maybe<Scalars["String"]>>>
  availableCmsProvisioningVendors?: Maybe<Array<Maybe<CmsProvider>>>
  availableCmsStarters?: Maybe<Array<Maybe<CmsProvisioningStarter>>>
  availableContentfulOrganizationsForUser?: Maybe<
    Array<Maybe<ContentfulOrganization>>
  >
  availableReportPlugins?: Maybe<Array<Maybe<ReportPlugin>>>
  availableSourceProviders?: Maybe<Array<Maybe<SourceControl>>>
  availableSourceProvidersWithVcsConfig?: Maybe<Array<Maybe<SourceControl>>>
  availableStarterTemplatesByVendor?: Maybe<
    Array<Maybe<ProjectStarterTemplate>>
  >
  availableSubscriptionPlans?: Maybe<Array<Maybe<SubscriptionPlan>>>
  betaAccessInvitations?: Maybe<InvitationListResult>
  branchesForRepository?: Maybe<BranchListResults>
  branchesForSite: BranchListResults
  branchesForSourceRepository: BranchListResults
  buildBranchCounts?: Maybe<BuildBranchCounts>
  buildBranchesByType?: Maybe<Array<Maybe<Build>>>
  buildById?: Maybe<Build>
  buildsForPullRequest?: Maybe<BuildResults>
  buildsForSite?: Maybe<BuildResults>
  buildsForSiteByFilterParams?: Maybe<BuildResults>
  canInteractWithWorkspace?: Maybe<Scalars["Boolean"]>
  cmsHealthChecksForResource?: Maybe<Array<Maybe<CmsHealthCheck>>>
  cmsIntegrationForProvisioning?: Maybe<CmsProvider>
  cmsIntegrationsForSite?: Maybe<Array<Maybe<CmsProvider>>>
  cmsVendorsForGatsbyProvisionScript?: Maybe<Array<Maybe<CmsVendor>>>
  contentLoaderInfo?: Maybe<ContentLoaderInfo>
  contentfulSpacesForIntegration?: Maybe<Array<Maybe<ContentfulSpace>>>
  contributorsByOrganization?: Maybe<Array<Maybe<Contributor>>>
  contributorsBySite?: Maybe<Array<Maybe<Contributor>>>
  cosmicCMSBucketsForIntegration?: Maybe<Array<Maybe<CosmicCmsBucket>>>
  currentOrganizations?: Maybe<Array<Maybe<Organization>>>
  currentUser?: Maybe<User>
  dataPointsForMetric?: Maybe<Array<Maybe<Datapoint>>>
  datoCMSProjectsForIntegration?: Maybe<Array<Maybe<DatoCmsProject>>>
  environmentVariablesForSite?: Maybe<Array<Maybe<Tag>>>
  firebaseProjectsForSiteId?: Maybe<FirebaseResults>
  firebaseSitesForSiteId?: Maybe<FirebaseResults>
  functionEntry: SiteFunctionEntry
  functionInvocations: Array<FunctionInvocation>
  functionLogs?: Maybe<Array<Log>>
  functionsForSite?: Maybe<Array<SiteFunctionEntry>>
  gatsbyDependenciesForSite?: Maybe<Array<Maybe<GatsbyDependency>>>
  gatsbyVersionsForUpgrade?: Maybe<Array<Maybe<GatsbyPluginVersion>>>
  getBuildQueueItemsForWorkspace?: Maybe<QueueItemResult>
  getLargestSitePlatformLimitOnWorkspace?: Maybe<PlatformLimitSummary>
  getLogDrainIntegrationByProviderAndSite?: Maybe<LogDrainIntegration>
  getMerlinStatusForSite?: Maybe<FullMerlinStatus>
  getSiteTransferInvitation?: Maybe<Invitation>
  githubRepoInformation: GithubRepoInfoResult
  hasSSOIntegration?: Maybe<Scalars["Boolean"]>
  hostingDetailsForSite?: Maybe<Array<Maybe<HostingDetails>>>
  installationsForUser?: Maybe<Array<Maybe<SourceInstallation>>>
  invitationById?: Maybe<Invitation>
  isSiteBeingTransferred?: Maybe<Scalars["Boolean"]>
  latestBuild?: Maybe<Build>
  latestBuildByStatus?: Maybe<Build>
  latestBuildByStatusByPullRequestId?: Maybe<Build>
  logCountsForBuild?: Maybe<StructuredLogCounts>
  logsForBuild?: Maybe<Array<Maybe<Log>>>
  logsForMerlinSourceEvent?: Maybe<Array<Maybe<Log>>>
  logsForSiteProvisionJob?: Maybe<Array<Maybe<Log>>>
  merlinSourceEventById?: Maybe<MerlinSourceEvent>
  merlinSourceEventsByResourceId?: Maybe<Array<Maybe<MerlinSourceEvent>>>
  merlinStatusForResource?: Maybe<FullMerlinStatus>
  netlifyAccountsForGatsbySiteId?: Maybe<Array<Maybe<NetlifyAccount>>>
  netlifySitesForGatsbySiteId?: Maybe<Array<Maybe<NetlifySite>>>
  notificationIntegrations?: Maybe<Array<Maybe<NotificationIntegration>>>
  nowProjectsForGatsbySiteId?: Maybe<Array<Maybe<NowProject>>>
  nowTeamsForGatsbySiteId?: Maybe<Array<Maybe<NowTeam>>>
  organizationDetails?: Maybe<Organization>
  paginatedMerlinSourceEventsByResourceId?: Maybe<MerlinSourceEventResults>
  ping: Scalars["String"]
  platformLimitSummaries?: Maybe<Array<Maybe<PlatformLimitSummary>>>
  platformLimitSummariesForWorkspaces?: Maybe<
    Array<Maybe<PlatformLimitSummaryForWorkspace>>
  >
  previewBuildsForSite?: Maybe<BuildResults>
  previewManifestInfo?: Maybe<PreviewManifestInfo>
  publicVcsConfigById?: Maybe<PublicEnterpriseVcsConfig>
  publicVcsConfigsByWorkspace?: Maybe<Array<Maybe<PublicEnterpriseVcsConfig>>>
  pullRequestById?: Maybe<PullRequest>
  pullRequestsForSite?: Maybe<PullRequestResults>
  repoHealthChecksForBranch?: Maybe<RepoHealthCheck>
  report: Report
  reportsForBuild?: Maybe<Array<Maybe<Report>>>
  reportsForSite?: Maybe<Array<Maybe<Report>>>
  repositoriesForInstallation?: Maybe<Array<Maybe<Repository>>>
  repositoriesForSourceProviderTeam: Array<Maybe<Repository>>
  repositoryFromSite?: Maybe<Repository>
  sanityCMSDatasetsForIntegration?: Maybe<Array<Maybe<SanityDataset>>>
  sanityCMSProjectsForIntegration?: Maybe<Array<Maybe<SanityProject>>>
  shopifyAppIntegration?: Maybe<ShopifyAppIntegration>
  siteDetails?: Maybe<Site>
  siteDetailsByBuildId?: Maybe<Site>
  siteHasGatsbyProvisionScript: Scalars["Boolean"]
  sitePreviewAuthToken?: Maybe<Scalars["String"]>
  siteSatisfiesDependencyRange?: Maybe<Scalars["Boolean"]>
  siteSettings?: Maybe<SiteSettings>
  siteSupportsContentSync?: Maybe<SiteSupportsContentSyncPayload>
  siteTransferDetails?: Maybe<SiteTransferDetails>
  sitesByOrganization?: Maybe<SitesByOrganizationListResult>
  sourceProviderTeamsForUser: Array<Maybe<SourceProviderTeam>>
  ssrInvocations: Array<SsrInvocation>
  ssrLogs: Array<Log>
  structuredLogsForBuild?: Maybe<Array<Maybe<StructuredLog>>>
  structuredLogsForMerlinSourceEvent?: Maybe<Array<Maybe<StructuredLog>>>
  supportedCDNIntegrations?: Maybe<Array<Maybe<CdnIntegration>>>
  validateSitePublicName?: Maybe<MutationResult>
  vcsHealthChecksForWorkspace?: Maybe<Array<Maybe<VcsHealthCheck>>>
  workspaceInvitations?: Maybe<WorkspaceMembersResult>
  workspaceMemberResources?: Maybe<Array<Maybe<CloudResource>>>
  workspaceMembers?: Maybe<WorkspaceMembersResult>
  workspaceMembersSimplified?: Maybe<WorkspaceMembersResult>
}

export type QueryActiveAndStaleBuildsArgs = {
  siteId: Scalars["UUID"]
}

export type QueryActiveBuildBranchesArgs = {
  siteId: Scalars["UUID"]
}

export type QueryActiveCmsIntegrationForSiteArgs = {
  siteId: Scalars["UUID"]
}

export type QueryActiveCmsIntegrationsForSiteArgs = {
  siteId: Scalars["UUID"]
}

export type QueryAdminActiveCmsIntegrationsForSiteArgs = {
  siteId: Scalars["UUID"]
}

export type QueryAdminAvailableSubscriptionPlansArgs = {
  organizationId: Scalars["UUID"]
  interval: BillingInterval
}

export type QueryAdminAvailableUpgradesForSiteArgs = {
  siteId: Scalars["UUID"]
}

export type QueryAdminBuildsBySiteIdArgs = {
  id: Scalars["UUID"]
  pagination?: Maybe<CursorPagination>
}

export type QueryAdminContributorsByOrganizationArgs = {
  organizationId: Scalars["UUID"]
}

export type QueryAdminContributorsBySiteArgs = {
  id: Scalars["UUID"]
}

export type QueryAdminDependencyByNameArgs = {
  name: Scalars["String"]
}

export type QueryAdminEnterprisePlansArgs = {
  interval: BillingInterval
}

export type QueryAdminGatsbyDependenciesForSiteArgs = {
  siteId: Scalars["UUID"]
}

export type QueryAdminGithubInstallationRepositoriesArgs = {
  installationId: Scalars["String"]
}

export type QueryAdminIsUsageCapEnforcedArgs = {
  organizationId: Scalars["UUID"]
}

export type QueryAdminLoginUrlArgs = {
  id: Scalars["UUID"]
  email: Scalars["String"]
}

export type QueryAdminLogsForBuildArgs = {
  siteId: Scalars["UUID"]
  buildId: Scalars["UUID"]
}

export type QueryAdminOrganizationByIdArgs = {
  id: Scalars["UUID"]
}

export type QueryAdminOrganizationGithubInstallationRepositoriesArgs = {
  organizationId: Scalars["UUID"]
}

export type QueryAdminOrganizationHasActiveGithubInstallationArgs = {
  organizationId: Scalars["UUID"]
}

export type QueryAdminOrganizationSearchArgs = {
  searchText: Scalars["String"]
}

export type QueryAdminOrganizationsByUserIdArgs = {
  id: Scalars["UUID"]
}

export type QueryAdminPlatformLimitSummariesArgs = {
  workspaceId: Scalars["UUID"]
}

export type QueryAdminPlatformResourceLimitsArgs = {
  workspaceId?: Maybe<Scalars["UUID"]>
  siteId: Scalars["UUID"]
}

export type QueryAdminRepositoryHasSiteArgs = {
  repositoryId: Scalars["String"]
}

export type QueryAdminResourceFlagsArgs = {
  resourceId: Scalars["UUID"]
}

export type QueryAdminSsoIntegrationByWorkspaceIdArgs = {
  workspaceId: Scalars["UUID"]
}

export type QueryAdminSiteByIdArgs = {
  id: Scalars["UUID"]
}

export type QueryAdminSiteLastCommitDateArgs = {
  siteId: Scalars["UUID"]
}

export type QueryAdminSiteResourceLimitArgs = {
  siteId: Scalars["UUID"]
}

export type QueryAdminSiteSearchArgs = {
  searchText: Scalars["String"]
}

export type QueryAdminSitesByOrganizationArgs = {
  organizationId: Scalars["UUID"]
}

export type QueryAdminSitesByUserIdArgs = {
  id: Scalars["UUID"]
}

export type QueryAdminSsoIntegrationAdminUrlArgs = {
  workspaceId: Scalars["UUID"]
}

export type QueryAdminUserSearchByTextArgs = {
  searchText: Scalars["String"]
}

export type QueryAvailableContentfulOrganizationsForUserArgs = {
  siteId: Scalars["UUID"]
}

export type QueryAvailableReportPluginsArgs = {
  siteId: Scalars["UUID"]
}

export type QueryAvailableSourceProvidersWithVcsConfigArgs = {
  workspaceId?: Maybe<Scalars["UUID"]>
}

export type QueryAvailableStarterTemplatesByVendorArgs = {
  vendor: CmsVendor
}

export type QueryAvailableSubscriptionPlansArgs = {
  organizationId?: Maybe<Scalars["UUID"]>
  interval: BillingInterval
  group?: Maybe<Scalars["String"]>
}

export type QueryBetaAccessInvitationsArgs = {
  pagination?: Maybe<Pagination>
  searchText?: Maybe<Scalars["String"]>
  hasSent?: Maybe<Scalars["Boolean"]>
}

export type QueryBranchesForRepositoryArgs = {
  endCursor?: Maybe<Scalars["String"]>
  searchText?: Maybe<Scalars["String"]>
  siteId?: Maybe<Scalars["UUID"]>
  nameWithOwner?: Maybe<Scalars["String"]>
}

export type QueryBranchesForSiteArgs = {
  endCursor?: Maybe<Scalars["String"]>
  searchText?: Maybe<Scalars["String"]>
  siteId: Scalars["UUID"]
}

export type QueryBranchesForSourceRepositoryArgs = {
  endCursor?: Maybe<Scalars["String"]>
  searchText?: Maybe<Scalars["String"]>
  nameWithOwner: Scalars["String"]
  provider: SourceControlProvider
}

export type QueryBuildBranchCountsArgs = {
  siteId: Scalars["UUID"]
}

export type QueryBuildBranchesByTypeArgs = {
  siteId: Scalars["UUID"]
  type: BranchType
  pagination?: Maybe<Pagination>
  branch?: Maybe<Scalars["String"]>
}

export type QueryBuildByIdArgs = {
  buildId: Scalars["UUID"]
}

export type QueryBuildsForPullRequestArgs = {
  id: Scalars["UUID"]
  pagination?: Maybe<CursorPagination>
}

export type QueryBuildsForSiteArgs = {
  siteId: Scalars["UUID"]
  pagination?: Maybe<CursorPagination>
  branch?: Maybe<Scalars["String"]>
  runnerType?: Maybe<BuildRunnerType>
}

export type QueryBuildsForSiteByFilterParamsArgs = {
  siteId: Scalars["UUID"]
  pagination?: Maybe<CursorPagination>
  branch?: Maybe<Scalars["String"]>
  runnerType?: Maybe<BuildRunnerType>
  buildStatus?: Maybe<BuildStatus>
  buildType?: Maybe<BuildType>
  date?: Maybe<Scalars["DateTime"]>
  startDate?: Maybe<Scalars["DateTime"]>
  endDate?: Maybe<Scalars["DateTime"]>
  keyword?: Maybe<Scalars["String"]>
}

export type QueryCanInteractWithWorkspaceArgs = {
  workspaceId: Scalars["UUID"]
  token?: Maybe<Scalars["String"]>
}

export type QueryCmsHealthChecksForResourceArgs = {
  resourceId: Scalars["UUID"]
  resourceType: MerlinSourceEventResourceType
}

export type QueryCmsIntegrationForProvisioningArgs = {
  siteId: Scalars["UUID"]
  vendor?: Maybe<CmsVendor>
}

export type QueryCmsIntegrationsForSiteArgs = {
  siteId: Scalars["UUID"]
  connected?: Maybe<Scalars["Boolean"]>
}

export type QueryCmsVendorsForGatsbyProvisionScriptArgs = {
  siteId: Scalars["UUID"]
}

export type QueryContentLoaderInfoArgs = {
  siteId: Scalars["UUID"]
}

export type QueryContentfulSpacesForIntegrationArgs = {
  siteId: Scalars["UUID"]
}

export type QueryContributorsByOrganizationArgs = {
  id: Scalars["UUID"]
}

export type QueryContributorsBySiteArgs = {
  id: Scalars["UUID"]
}

export type QueryCosmicCmsBucketsForIntegrationArgs = {
  siteId: Scalars["UUID"]
}

export type QueryDataPointsForMetricArgs = {
  siteId: Scalars["UUID"]
  metricKey: Scalars["ID"]
  startDate?: Maybe<Scalars["DateTime"]>
  endDate?: Maybe<Scalars["DateTime"]>
  vendor?: Maybe<ReportPluginVendor>
}

export type QueryDatoCmsProjectsForIntegrationArgs = {
  siteId: Scalars["UUID"]
}

export type QueryEnvironmentVariablesForSiteArgs = {
  id: Scalars["UUID"]
  runnerType?: Maybe<BuildRunnerType>
}

export type QueryFirebaseProjectsForSiteIdArgs = {
  siteId: Scalars["UUID"]
}

export type QueryFirebaseSitesForSiteIdArgs = {
  siteId: Scalars["UUID"]
}

export type QueryFunctionEntryArgs = {
  siteId: Scalars["UUID"]
  functionId: Scalars["UUID"]
}

export type QueryFunctionInvocationsArgs = {
  siteId: Scalars["UUID"]
  buildId?: Maybe<Scalars["UUID"]>
  functionId: Scalars["UUID"]
  beforeStartedAt?: Maybe<Scalars["DateTime"]>
  limit?: Maybe<Scalars["Int"]>
}

export type QueryFunctionLogsArgs = {
  siteId: Scalars["UUID"]
  buildId?: Maybe<Scalars["UUID"]>
  functionId: Scalars["UUID"]
}

export type QueryFunctionsForSiteArgs = {
  siteId: Scalars["UUID"]
  buildId?: Maybe<Scalars["UUID"]>
}

export type QueryGatsbyDependenciesForSiteArgs = {
  siteId: Scalars["UUID"]
}

export type QueryGatsbyVersionsForUpgradeArgs = {
  siteId: Scalars["UUID"]
  runnerType?: Maybe<BuildRunnerType>
}

export type QueryGetBuildQueueItemsForWorkspaceArgs = {
  workspaceId: Scalars["UUID"]
  pagination?: Maybe<CursorPagination>
}

export type QueryGetLargestSitePlatformLimitOnWorkspaceArgs = {
  workspaceId: Scalars["UUID"]
  name: PlatformLimitSummaryName
}

export type QueryGetLogDrainIntegrationByProviderAndSiteArgs = {
  siteId: Scalars["UUID"]
  logDrainProvider: LogDrainProvider
}

export type QueryGetMerlinStatusForSiteArgs = {
  siteId: Scalars["UUID"]
}

export type QueryGetSiteTransferInvitationArgs = {
  id: Scalars["UUID"]
}

export type QueryGithubRepoInformationArgs = {
  githubUrl: Scalars["String"]
}

export type QueryHasSsoIntegrationArgs = {
  workspaceId: Scalars["UUID"]
}

export type QueryHostingDetailsForSiteArgs = {
  siteId: Scalars["UUID"]
}

export type QueryInvitationByIdArgs = {
  id: Scalars["UUID"]
}

export type QueryIsSiteBeingTransferredArgs = {
  id: Scalars["UUID"]
}

export type QueryLatestBuildArgs = {
  siteId: Scalars["UUID"]
  branch: Scalars["String"]
  runnerType: BuildRunnerType
}

export type QueryLatestBuildByStatusArgs = {
  siteId: Scalars["UUID"]
  branch: Scalars["String"]
  runnerType: BuildRunnerType
  status: BuildStatus
}

export type QueryLatestBuildByStatusByPullRequestIdArgs = {
  siteId: Scalars["UUID"]
  pullRequestId: Scalars["UUID"]
  status: BuildStatus
}

export type QueryLogCountsForBuildArgs = {
  siteId: Scalars["UUID"]
  buildId: Scalars["UUID"]
}

export type QueryLogsForBuildArgs = {
  siteId: Scalars["UUID"]
  buildId: Scalars["UUID"]
  offset?: Maybe<Scalars["Int"]>
}

export type QueryLogsForMerlinSourceEventArgs = {
  sourceEventId: Scalars["ID"]
  offset?: Maybe<Scalars["Int"]>
}

export type QueryLogsForSiteProvisionJobArgs = {
  siteId: Scalars["UUID"]
  siteProvisionJobId: Scalars["ID"]
  offset?: Maybe<Scalars["Int"]>
}

export type QueryMerlinSourceEventByIdArgs = {
  sourceEventId: Scalars["ID"]
}

export type QueryMerlinSourceEventsByResourceIdArgs = {
  resourceId: Scalars["UUID"]
  resourceType: MerlinSourceEventResourceType
  cmsVendor?: Maybe<CmsVendor>
}

export type QueryMerlinStatusForResourceArgs = {
  resourceId: Scalars["UUID"]
  resourceType?: Maybe<MerlinSourceEventResourceType>
}

export type QueryNetlifyAccountsForGatsbySiteIdArgs = {
  siteId: Scalars["UUID"]
}

export type QueryNetlifySitesForGatsbySiteIdArgs = {
  siteId: Scalars["UUID"]
  slug: Scalars["String"]
}

export type QueryNotificationIntegrationsArgs = {
  resourceId: Scalars["String"]
  resourceType: CloudResourceType
}

export type QueryNowProjectsForGatsbySiteIdArgs = {
  siteId: Scalars["UUID"]
  teamId?: Maybe<Scalars["String"]>
}

export type QueryNowTeamsForGatsbySiteIdArgs = {
  siteId: Scalars["UUID"]
}

export type QueryOrganizationDetailsArgs = {
  id: Scalars["UUID"]
}

export type QueryPaginatedMerlinSourceEventsByResourceIdArgs = {
  resourceId: Scalars["UUID"]
  resourceType: MerlinSourceEventResourceType
  cmsVendor?: Maybe<CmsVendor>
  pagination?: Maybe<CursorPagination>
}

export type QueryPlatformLimitSummariesArgs = {
  workspaceId: Scalars["UUID"]
}

export type QueryPlatformLimitSummariesForWorkspacesArgs = {
  workspaceIds: Array<Scalars["UUID"]>
}

export type QueryPreviewBuildsForSiteArgs = {
  siteId: Scalars["UUID"]
  pagination?: Maybe<CursorPagination>
}

export type QueryPreviewManifestInfoArgs = {
  siteId: Scalars["UUID"]
  manifestId: Scalars["String"]
}

export type QueryPublicVcsConfigByIdArgs = {
  id: Scalars["UUID"]
}

export type QueryPublicVcsConfigsByWorkspaceArgs = {
  workspaceId: Scalars["UUID"]
}

export type QueryPullRequestByIdArgs = {
  id: Scalars["UUID"]
}

export type QueryPullRequestsForSiteArgs = {
  siteId: Scalars["UUID"]
  searchText?: Maybe<Scalars["String"]>
  status?: Maybe<PullRequestStatus>
  pagination?: Maybe<CursorPagination>
}

export type QueryRepoHealthChecksForBranchArgs = {
  provider?: Maybe<SourceControlProvider>
  enterpriseVCSConfigId?: Maybe<Scalars["UUID"]>
  nameWithOwner: Scalars["String"]
  directoryPath?: Maybe<Scalars["String"]>
  branch?: Maybe<Scalars["String"]>
}

export type QueryReportArgs = {
  id: Scalars["ID"]
  siteId: Scalars["UUID"]
}

export type QueryReportsForBuildArgs = {
  siteId: Scalars["UUID"]
  buildId: Scalars["UUID"]
}

export type QueryReportsForSiteArgs = {
  siteId: Scalars["UUID"]
  branch?: Maybe<Scalars["String"]>
  vendor?: Maybe<ReportPluginVendor>
  startDate?: Maybe<Scalars["DateTime"]>
  endDate?: Maybe<Scalars["DateTime"]>
}

export type QueryRepositoriesForInstallationArgs = {
  installationId: Scalars["String"]
}

export type QueryRepositoriesForSourceProviderTeamArgs = {
  teamId: Scalars["String"]
  provider: SourceControlProvider
  enterpriseVCSConfigId?: Maybe<Scalars["UUID"]>
  isUserTeam?: Maybe<Scalars["Boolean"]>
}

export type QueryRepositoryFromSiteArgs = {
  siteId: Scalars["UUID"]
}

export type QuerySanityCmsDatasetsForIntegrationArgs = {
  siteId: Scalars["UUID"]
  projectId: Scalars["String"]
}

export type QuerySanityCmsProjectsForIntegrationArgs = {
  siteId: Scalars["UUID"]
}

export type QueryShopifyAppIntegrationArgs = {
  shopName: Scalars["String"]
  sessionToken: Scalars["String"]
}

export type QuerySiteDetailsArgs = {
  id: Scalars["UUID"]
}

export type QuerySiteDetailsByBuildIdArgs = {
  buildId: Scalars["UUID"]
}

export type QuerySiteHasGatsbyProvisionScriptArgs = {
  siteId: Scalars["UUID"]
}

export type QuerySitePreviewAuthTokenArgs = {
  siteId: Scalars["UUID"]
}

export type QuerySiteSatisfiesDependencyRangeArgs = {
  siteId: Scalars["UUID"]
  dependencyName: Scalars["String"]
  dependencyRange: Scalars["String"]
  featureName?: Maybe<Scalars["String"]>
}

export type QuerySiteSettingsArgs = {
  siteId: Scalars["UUID"]
}

export type QuerySiteSupportsContentSyncArgs = {
  pluginName: Scalars["String"]
  siteId: Scalars["UUID"]
}

export type QuerySiteTransferDetailsArgs = {
  siteId: Scalars["UUID"]
}

export type QuerySitesByOrganizationArgs = {
  organizationId?: Maybe<Scalars["UUID"]>
}

export type QuerySourceProviderTeamsForUserArgs = {
  provider: SourceControlProvider
  enterpriseVCSConfigId?: Maybe<Scalars["UUID"]>
}

export type QuerySsrInvocationsArgs = {
  siteId: Scalars["UUID"]
  buildId: Scalars["UUID"]
}

export type QuerySsrLogsArgs = {
  siteId: Scalars["UUID"]
  buildId: Scalars["UUID"]
}

export type QueryStructuredLogsForBuildArgs = {
  siteId: Scalars["UUID"]
  buildId: Scalars["UUID"]
  logLevel: StructuredLogLevel
}

export type QueryStructuredLogsForMerlinSourceEventArgs = {
  sourceEventId: Scalars["ID"]
  cmsVendor?: Maybe<CmsVendor>
  offset?: Maybe<Scalars["Int"]>
}

export type QuerySupportedCdnIntegrationsArgs = {
  siteId: Scalars["UUID"]
}

export type QueryValidateSitePublicNameArgs = {
  name: Scalars["String"]
  organizationId?: Maybe<Scalars["UUID"]>
  sourceOrganizationId?: Maybe<Scalars["String"]>
  sourceControlProvider?: Maybe<SourceControlProvider>
  siteId?: Maybe<Scalars["UUID"]>
}

export type QueryVcsHealthChecksForWorkspaceArgs = {
  workspaceId: Scalars["UUID"]
}

export type QueryWorkspaceInvitationsArgs = {
  workspaceId: Scalars["UUID"]
}

export type QueryWorkspaceMemberResourcesArgs = {
  workspaceId: Scalars["UUID"]
  memberId: Scalars["UUID"]
}

export type QueryWorkspaceMembersArgs = {
  workspaceId: Scalars["UUID"]
  offset?: Maybe<Scalars["Int"]>
  limit?: Maybe<Scalars["Int"]>
}

export type QueryWorkspaceMembersSimplifiedArgs = {
  workspaceId: Scalars["UUID"]
  offset?: Maybe<Scalars["Int"]>
  limit?: Maybe<Scalars["Int"]>
}

export type QueueItem = {
  __typename?: "QueueItem"
  id: Scalars["String"]
  siteId: Scalars["UUID"]
  workspaceId: Scalars["UUID"]
  branch: Scalars["String"]
  buildId: Scalars["UUID"]
  site?: Maybe<Site>
  build?: Maybe<Build>
  status?: Maybe<QueuedItemStatus>
}

export type QueueItemResult = {
  __typename?: "QueueItemResult"
  pageInfo?: Maybe<CursorPageInfo>
  buildQueueItems?: Maybe<Array<Maybe<QueueItem>>>
}

export type QueueJob = {
  __typename?: "QueueJob"
  id: Scalars["String"]
}

export type QueueStatus = {
  __typename?: "QueueStatus"
  name: Scalars["String"]
  waiting?: Maybe<Scalars["Int"]>
  active?: Maybe<Scalars["Int"]>
  succeeded?: Maybe<Scalars["Int"]>
  failed?: Maybe<Scalars["Int"]>
  delayed?: Maybe<Scalars["Int"]>
  newestJob?: Maybe<Scalars["Int"]>
  activeJobs: Array<QueueJob>
  waitingJobs: Array<QueueJob>
  failedJobs: Array<QueueJob>
  delayedJobs: Array<QueueJob>
}

export enum QueuedItemStatus {
  Queued = "QUEUED",
  Pending = "PENDING",
  Ready = "READY",
  InProgress = "IN_PROGRESS",
  Finished = "FINISHED",
  Error = "ERROR",
  Skipped = "SKIPPED",
  Canceled = "CANCELED",
  TimedOut = "TIMED_OUT",
}

export type RealTimeEditSummary = {
  __typename?: "RealTimeEditSummary"
  id: Scalars["ID"]
  organizationId: Scalars["UUID"]
  limit?: Maybe<Scalars["Int"]>
  dailyAverage?: Maybe<Scalars["Float"]>
  dailyMax?: Maybe<Scalars["Int"]>
  total?: Maybe<Scalars["Int"]>
  interval: UsageInterval
  numberOfDaysOverLimit?: Maybe<Scalars["Int"]>
  averageRTEsOverLimit?: Maybe<Scalars["Int"]>
  RTEsInCurrentDay?: Maybe<Scalars["Int"]>
  RTEsInLastDay?: Maybe<Scalars["Int"]>
  RTEsInCurrentPeriod?: Maybe<Scalars["Int"]>
  RTEsInLastPeriod?: Maybe<Scalars["Int"]>
  averageRTEsLast3Periods?: Maybe<Scalars["Int"]>
  buildsRTEsCurrentPeriod?: Maybe<Scalars["Int"]>
}

export type RebuildSiteResult = {
  __typename?: "RebuildSiteResult"
  site?: Maybe<Site>
  build?: Maybe<Build>
}

export type RepoHealthCheck = {
  __typename?: "RepoHealthCheck"
  repoName: Scalars["String"]
  repoUrl?: Maybe<Scalars["String"]>
  branch: Scalars["String"]
  plugins?: Maybe<Array<Maybe<RepoPlugin>>>
}

export type RepoPlugin = {
  __typename?: "RepoPlugin"
  name: Scalars["String"]
  currentVersion: Scalars["String"]
  latestVersion: Scalars["String"]
  pluginUrl: Scalars["String"]
  maintainer: Scalars["String"]
}

export type Report = {
  __typename?: "Report"
  id: Scalars["ID"]
  vendor?: Maybe<ReportPluginVendor>
  siteId: Scalars["UUID"]
  branch?: Maybe<Scalars["String"]>
  buildId: Scalars["UUID"]
  artifacts?: Maybe<Array<Maybe<ReportArtifact>>>
  createdAt: Scalars["DateTime"]
  metrics?: Maybe<Array<Maybe<ReportMetric>>>
}

export type ReportArtifact = {
  __typename?: "ReportArtifact"
  id: Scalars["ID"]
  destinationUrl: Scalars["String"]
}

export type ReportMetric = {
  __typename?: "ReportMetric"
  id: Scalars["ID"]
  value: Scalars["Int"]
  contextValue?: Maybe<Scalars["String"]>
  key: Scalars["ID"]
  unit?: Maybe<MetricUnit>
  time: Scalars["DateTime"]
}

export type ReportPlugin = {
  __typename?: "ReportPlugin"
  id: Scalars["ID"]
  name?: Maybe<Scalars["String"]>
  vendor?: Maybe<ReportPluginVendor>
  description?: Maybe<Scalars["String"]>
  enabled: Scalars["Boolean"]
}

export enum ReportPluginVendor {
  Lighthouse = "LIGHTHOUSE",
  LinkChecker = "LINK_CHECKER",
}

export type Repository = {
  __typename?: "Repository"
  id: Scalars["String"]
  name: Scalars["String"]
  description?: Maybe<Scalars["String"]>
  nameWithOwner: Scalars["String"]
  ownerId?: Maybe<Scalars["String"]>
  isPrivate?: Maybe<Scalars["Boolean"]>
  provider?: Maybe<SourceControlProvider>
  url: Scalars["String"]
  updatedAt?: Maybe<Scalars["DateTime"]>
  createdAt?: Maybe<Scalars["DateTime"]>
  defaultBranch?: Maybe<Scalars["String"]>
}

export type RepositoryListResults = {
  __typename?: "RepositoryListResults"
  repos?: Maybe<Array<Maybe<Repository>>>
  pageInfo?: Maybe<GithubPagination>
}

export type RequestPlanChangeInfoInput = {
  firstName: Scalars["String"]
  lastName: Scalars["String"]
  email: Scalars["String"]
  plan: PlanChangeRequest
  currentPlan?: Maybe<Scalars["String"]>
  hostingTier?: Maybe<Scalars["String"]>
  buildsTier?: Maybe<Scalars["String"]>
  billingInterval?: Maybe<Scalars["String"]>
  nextTier?: Maybe<Scalars["String"]>
  nextHostingTier?: Maybe<Scalars["String"]>
  nextBuildsTier?: Maybe<Scalars["String"]>
  nextBillingInterval?: Maybe<Scalars["String"]>
  reason: Scalars["String"]
  downgradeReason?: Maybe<Scalars["String"]>
  userId?: Maybe<Scalars["UUID"]>
  organizationId?: Maybe<Scalars["UUID"]>
  subscriptionStartedAt?: Maybe<Scalars["DateTime"]>
}

export type ResourceFlag = {
  __typename?: "ResourceFlag"
  id?: Maybe<Scalars["ID"]>
  name?: Maybe<Scalars["String"]>
  resourceId?: Maybe<Scalars["String"]>
  enabled?: Maybe<Scalars["Boolean"]>
}

export type ResourcePermissionMap = {
  __typename?: "ResourcePermissionMap"
  delete?: Maybe<Scalars["Boolean"]>
  create?: Maybe<Scalars["Boolean"]>
  read?: Maybe<Scalars["Boolean"]>
  edit?: Maybe<Scalars["Boolean"]>
}

export type RoutingTarget = {
  __typename?: "RoutingTarget"
  prettyHostname: Scalars["String"]
  targetHostname: Scalars["String"]
  siteId: Scalars["UUID"]
  organizationId: Scalars["UUID"]
  branch: Scalars["String"]
  sanitizedBranch?: Maybe<Scalars["String"]>
}

export enum RoutingType {
  ProductionBuild = "PRODUCTION_BUILD",
  GatsbyPreview = "GATSBY_PREVIEW",
  DeployPreview = "DEPLOY_PREVIEW",
}

export type RunnerState = {
  __typename?: "RunnerState"
  status?: Maybe<Scalars["String"]>
  statusDate?: Maybe<Scalars["DateTime"]>
  lastStartedActivity?: Maybe<Scalars["String"]>
  lastStartedActivityDate?: Maybe<Scalars["DateTime"]>
  lastEndedActivity?: Maybe<Scalars["String"]>
  lastEndedActivityDate?: Maybe<Scalars["DateTime"]>
  stateMachineState?: Maybe<Scalars["String"]>
  stateMachineStateDate?: Maybe<Scalars["DateTime"]>
  branch?: Maybe<Scalars["String"]>
  runnerType?: Maybe<BuildRunnerType>
  currentBuildId?: Maybe<Scalars["String"]>
}

export type S3ConnectionInput = {
  accessKeyId: Scalars["String"]
  secretAccessKey: Scalars["String"]
  bucket: Scalars["String"]
  fileKeyPrefix?: Maybe<Scalars["String"]>
  cloudFrontDistributionId?: Maybe<Scalars["String"]>
  invalidationPaths?: Maybe<Scalars["String"]>
}

export enum SalesforceSiteType {
  Autoprovision = "AUTOPROVISION",
  HasRepo = "HAS_REPO",
}

export type SanityDataset = {
  __typename?: "SanityDataset"
  name: Scalars["String"]
  aclMode: Scalars["String"]
}

export type SanityProject = {
  __typename?: "SanityProject"
  id: Scalars["String"]
  name: Scalars["String"]
  selectedDataset?: Maybe<Scalars["String"]>
  datasets: Array<Maybe<SanityDataset>>
  selected?: Maybe<Scalars["Boolean"]>
}

export type ShopifyAppIntegration = {
  __typename?: "ShopifyAppIntegration"
  id: Scalars["UUID"]
  siteId: Scalars["UUID"]
  shopName: Scalars["String"]
  shopifyToken: Scalars["String"]
  site?: Maybe<Site>
  hostingDetails?: Maybe<Array<Maybe<HostingDetails>>>
  gatsbyHostingOn?: Maybe<Scalars["Boolean"]>
}

export type Site = {
  __typename?: "Site"
  id: Scalars["UUID"]
  name: Scalars["String"]
  publicName?: Maybe<Scalars["String"]>
  sitePrefix?: Maybe<Scalars["String"]>
  siteSuffix?: Maybe<Scalars["String"]>
  description?: Maybe<Scalars["String"]>
  organizationId: Scalars["UUID"]
  repositoryId: Scalars["String"]
  repository?: Maybe<SourceControlRepository>
  createdAt: Scalars["DateTime"]
  updatedAt: Scalars["DateTime"]
  branch: Scalars["String"]
  publishBranch?: Maybe<Scalars["String"]>
  stableBuildURL?: Maybe<Scalars["String"]>
  previewUrl?: Maybe<Scalars["String"]>
  previewStatus?: Maybe<PreviewStatus>
  previewProtection?: Maybe<PreviewProtectionType>
  previewPassword?: Maybe<Scalars["String"]>
  previewProtectionIpRanges?: Maybe<Scalars["String"]>
  previewDirectory?: Maybe<Scalars["String"]>
  previewTriggerType?: Maybe<PreviewTriggerType>
  previewAuthenticationToken?: Maybe<Scalars["String"]>
  productionProtection?: Maybe<PreviewProtectionType>
  productionProtectionPassword?: Maybe<Scalars["String"]>
  productionProtectionIpRanges?: Maybe<Scalars["String"]>
  status?: Maybe<SiteStatus>
  permissions?: Maybe<PermissionsDigest>
  hostname: Scalars["String"]
  /** @deprecated Field no longer supported */
  envVars?: Maybe<Array<Maybe<Tag>>>
  previewEnvVars?: Maybe<Array<Maybe<Tag>>>
  buildEnvVars?: Maybe<Array<Maybe<Tag>>>
  versionsForUpgrade?: Maybe<Array<Maybe<GatsbyPluginVersion>>>
  latestHostingDeployVersion?: Maybe<Scalars["String"]>
  manualHostingDeploysEnabled?: Maybe<Scalars["Boolean"]>
  buildsEnabled?: Maybe<Scalars["Boolean"]>
  imageCdnEnabled?: Maybe<Scalars["Boolean"]>
  burstModeEnabled?: Maybe<Scalars["Boolean"]>
  incrementalPreviewsEnabled?: Maybe<Scalars["Boolean"]>
  incrementalBuildsEnabled?: Maybe<Scalars["Boolean"]>
  incrementalDeploysEnabled?: Maybe<Scalars["Boolean"]>
  incrementalDeploysProductionEnabled?: Maybe<Scalars["Boolean"]>
  previewBuildsEnabled?: Maybe<Scalars["Boolean"]>
  previewSourceUpdates?: Maybe<Scalars["Boolean"]>
  buildChecksEnabled?: Maybe<Scalars["Boolean"]>
  cdnIntegrations?: Maybe<Array<Maybe<CdnIntegration>>>
  organization?: Maybe<Organization>
  parentOrganizationId?: Maybe<Scalars["UUID"]>
  latestBuild?: Maybe<Build>
  latestPreview?: Maybe<Build>
  clusterName?: Maybe<Scalars["String"]>
  ssrClusterName?: Maybe<Scalars["String"]>
  functionsClusterName?: Maybe<Scalars["String"]>
  pageGenClusterName?: Maybe<Scalars["String"]>
  source?: Maybe<SourceControlProvider>
  sourceOrganizationId?: Maybe<Scalars["String"]>
  enterpriseVCSConfigId?: Maybe<Scalars["UUID"]>
  sourceOrganization?: Maybe<SourceOrganization>
  previewCacheKey?: Maybe<Scalars["String"]>
  merlinGraphQLApiEnabled?: Maybe<Scalars["Boolean"]>
  merlinPullRequestsSourcingEnabled?: Maybe<Scalars["Boolean"]>
  merlinPreviewSourcingEnabled?: Maybe<Scalars["Boolean"]>
  merlinProductionSourcingEnabled?: Maybe<Scalars["Boolean"]>
  slicesAPIEnabled?: Maybe<Scalars["Boolean"]>
  staticFileBucketName?: Maybe<Scalars["String"]>
  dataBuildsEnabled?: Maybe<Scalars["Boolean"]>
  gatsbyjsioEnabled?: Maybe<Scalars["Boolean"]>
}

export type SitePermissionsArgs = {
  viewerUserId?: Maybe<Scalars["UUID"]>
}

export type SiteDependency = {
  __typename?: "SiteDependency"
  id: Scalars["ID"]
  name: Scalars["String"]
  semver: Scalars["String"]
  diagnostics?: Maybe<Array<Maybe<DependencyDiagnostic>>>
  enabled?: Maybe<Scalars["Boolean"]>
}

export type SiteDependencyQueryInput = {
  semver: Scalars["String"]
  name: Scalars["String"]
}

export type SiteDependencyResult = {
  __typename?: "SiteDependencyResult"
  result?: Maybe<MutationResult>
  dependencies?: Maybe<Array<Maybe<SiteDependency>>>
}

export type SiteDependencyUpsertInput = {
  name: Scalars["String"]
  semver: Scalars["String"]
}

export type SiteFunctionEntry = {
  __typename?: "SiteFunctionEntry"
  id: Scalars["UUID"]
  siteId: Scalars["UUID"]
  creationBuildId: Scalars["UUID"]
  path: Scalars["String"]
  sha: Scalars["String"]
  status: FunctionStatus
}

export type SiteInitJob = {
  __typename?: "SiteInitJob"
  id: Scalars["ID"]
  workspaceId: Scalars["UUID"]
  status: SiteInitStatus
  siteId?: Maybe<Scalars["UUID"]>
  error?: Maybe<Scalars["String"]>
  repoUrl?: Maybe<Scalars["String"]>
}

export enum SiteInitStatus {
  InProgress = "IN_PROGRESS",
  CloningRepo = "CLONING_REPO",
  PushingRepo = "PUSHING_REPO",
  CreatingSite = "CREATING_SITE",
  Success = "SUCCESS",
  Failed = "FAILED",
}

export type SiteIntegration = {
  __typename?: "SiteIntegration"
  id: Scalars["UUID"]
  name: CmsVendor
  status: CmsIntegrationStatus
  logoUrl: Scalars["String"]
  features?: Maybe<IntegrationFeatures>
}

export type SiteProvisionJob = {
  __typename?: "SiteProvisionJob"
  id: Scalars["ID"]
  repoUrl: Scalars["String"]
  status?: Maybe<SiteProvisionStatus>
  workspaceId: Scalars["UUID"]
  siteId: Scalars["UUID"]
  error?: Maybe<Scalars["String"]>
}

export enum SiteProvisionStatus {
  InProgress = "IN_PROGRESS",
  CloningRepo = "CLONING_REPO",
  InstallingDependencies = "INSTALLING_DEPENDENCIES",
  RunningScript = "RUNNING_SCRIPT",
  Success = "SUCCESS",
  Failed = "FAILED",
}

export type SiteResourceLimit = {
  __typename?: "SiteResourceLimit"
  id: Scalars["ID"]
  siteId: Scalars["UUID"]
  cpuLimits: Scalars["String"]
  memoryLimits: Scalars["String"]
  cpuRequests: Scalars["String"]
  memoryRequests: Scalars["String"]
  updatedAt?: Maybe<Scalars["DateTime"]>
}

export type SiteResourceLimitsUpdateInput = {
  cpuLimits: Scalars["String"]
  cpuRequests: Scalars["String"]
  memoryLimits: Scalars["String"]
  memoryRequests: Scalars["String"]
}

export type SiteSettings = {
  __typename?: "SiteSettings"
  id: Scalars["ID"]
  siteId: Scalars["UUID"]
  imageCdnEnabled: Scalars["Boolean"]
  manualHostingDeploysEnabled: Scalars["Boolean"]
  buildsEnabled: Scalars["Boolean"]
  incrementalPreviewsEnabled: Scalars["Boolean"]
  incrementalBuildsEnabled: Scalars["Boolean"]
  previewBuildsEnabled: Scalars["Boolean"]
  previewSourceUpdates: Scalars["Boolean"]
  buildChecksEnabled: Scalars["Boolean"]
  burstModeEnabled: Scalars["Boolean"]
}

export enum SiteStatus {
  Deleted = "DELETED",
  Active = "ACTIVE",
  Pending = "PENDING",
  Provisioning = "PROVISIONING",
  Disabled = "DISABLED",
}

export type SiteSupportsContentSyncPayload = {
  __typename?: "SiteSupportsContentSyncPayload"
  sourcePlugin?: Maybe<Scalars["Boolean"]>
  gatsby?: Maybe<Scalars["Boolean"]>
  status?: Maybe<SiteSupportsContentSyncStatus>
}

export enum SiteSupportsContentSyncStatus {
  Error = "ERROR",
  Unavailable = "UNAVAILABLE",
  Success = "SUCCESS",
}

export type SiteTransferDetails = {
  __typename?: "SiteTransferDetails"
  siteId: Scalars["UUID"]
  siteName?: Maybe<Scalars["String"]>
  sitePublicName?: Maybe<Scalars["String"]>
  orgId?: Maybe<Scalars["UUID"]>
  orgName?: Maybe<Scalars["String"]>
}

export type SitesByOrganizationListResult = {
  __typename?: "SitesByOrganizationListResult"
  organizations?: Maybe<Array<Maybe<Organization>>>
  contributorOrganizations?: Maybe<Array<Maybe<Organization>>>
  total?: Maybe<Scalars["Int"]>
}

export type SourceCodeLocation = {
  __typename?: "SourceCodeLocation"
  start?: Maybe<SourceCodePosition>
  end?: Maybe<SourceCodePosition>
}

export type SourceCodePosition = {
  __typename?: "SourceCodePosition"
  line?: Maybe<Scalars["Int"]>
  column?: Maybe<Scalars["Int"]>
}

export type SourceControl = {
  __typename?: "SourceControl"
  source?: Maybe<SourceControlProvider>
  connected?: Maybe<Scalars["Boolean"]>
  vcsConfigId?: Maybe<Scalars["UUID"]>
}

export enum SourceControlProvider {
  GithubEnterprise = "GITHUB_ENTERPRISE",
  GitlabSelfManaged = "GITLAB_SELF_MANAGED",
  Github = "GITHUB",
  Bitbucket = "BITBUCKET",
  Gitlab = "GITLAB",
  Google = "GOOGLE",
  Workos = "WORKOS",
}

export type SourceControlRepository = {
  __typename?: "SourceControlRepository"
  id: Scalars["String"]
  name: Scalars["String"]
  nameWithOwner: Scalars["String"]
  description?: Maybe<Scalars["String"]>
  ownerId?: Maybe<Scalars["String"]>
  isPrivate?: Maybe<Scalars["Boolean"]>
  provider?: Maybe<SourceControlProvider>
  url: Scalars["String"]
  updatedAt?: Maybe<Scalars["DateTime"]>
  createdAt?: Maybe<Scalars["DateTime"]>
  sites?: Maybe<Array<Maybe<Site>>>
}

export type SourceInstallation = {
  __typename?: "SourceInstallation"
  id: Scalars["String"]
  name: Scalars["String"]
  targetType: Scalars["String"]
  targetId: Scalars["String"]
  repositorySelection: Scalars["String"]
  settingsUrl: Scalars["String"]
}

export type SourceOrganization = {
  __typename?: "SourceOrganization"
  id: Scalars["String"]
  name: Scalars["String"]
  token?: Maybe<Scalars["String"]>
  refreshToken?: Maybe<Scalars["String"]>
  tokenExpiresIn?: Maybe<Scalars["Float"]>
  resourceId?: Maybe<Scalars["UUID"]>
  enterpriseVCSConfigId?: Maybe<Scalars["UUID"]>
  source?: Maybe<SourceControlProvider>
  sourceId?: Maybe<Scalars["String"]>
  sourceToken?: Maybe<Scalars["String"]>
  permissions?: Maybe<Array<Maybe<SourcePermission>>>
  permissionsURL?: Maybe<Scalars["String"]>
}

export type SourcePermission = {
  __typename?: "SourcePermission"
  key: Scalars["String"]
  active: Scalars["Boolean"]
}

export type SourceProviderTeam = {
  __typename?: "SourceProviderTeam"
  id: Scalars["String"]
  name: Scalars["String"]
  isUserTeam?: Maybe<Scalars["Boolean"]>
}

export type SsoIntegration = {
  __typename?: "SsoIntegration"
  id: Scalars["ID"]
  workspaceId: Scalars["UUID"]
  ssoId: Scalars["String"]
  domains: Scalars["String"]
  status: SsoIntegrationStatus
}

export enum SsoIntegrationStatus {
  Pending = "PENDING",
  Connected = "CONNECTED",
  Disconnected = "DISCONNECTED",
}

export type SsrInvocation = {
  __typename?: "SsrInvocation"
  id: Scalars["UUID"]
  invocationId: Scalars["UUID"]
  logs: Array<Log>
  path: Scalars["String"]
  status: Scalars["Int"]
  siteId: Scalars["UUID"]
  buildId: Scalars["UUID"]
  startedAt?: Maybe<Scalars["DateTime"]>
  endedAt?: Maybe<Scalars["DateTime"]>
}

export type StructuredLog = {
  __typename?: "StructuredLog"
  id: Scalars["UUID"]
  message?: Maybe<Scalars["String"]>
  level?: Maybe<StructuredLogLevel>
  activity?: Maybe<BuildActivity>
  code?: Maybe<Scalars["String"]>
  stack?: Maybe<Array<Maybe<GatsbyCallSite>>>
  type?: Maybe<LogErrorType>
  filePath?: Maybe<Scalars["String"]>
  category?: Maybe<LogCategory>
  location?: Maybe<SourceCodeLocation>
  docsUrl?: Maybe<Scalars["String"]>
  errorUrl?: Maybe<Scalars["String"]>
  context?: Maybe<Scalars["JSON"]>
}

export type StructuredLogCounts = {
  __typename?: "StructuredLogCounts"
  WARNING?: Maybe<Scalars["Int"]>
  ERROR?: Maybe<Scalars["Int"]>
}

export enum StructuredLogLevel {
  All = "ALL",
  Log = "LOG",
  Warning = "WARNING",
  Info = "INFO",
  Success = "SUCCESS",
  Debug = "DEBUG",
  Error = "ERROR",
}

export type Subscription = {
  __typename?: "Subscription"
  siteChanged?: Maybe<Site>
  buildChanged?: Maybe<Build>
  buildCreated?: Maybe<Build>
  merlinStatusChanged?: Maybe<FullMerlinStatus>
  merlinSourceEventCreated?: Maybe<MerlinSourceEvent>
  merlinSourceEventChanged?: Maybe<MerlinSourceEvent>
  merlinRawLogsCreated?: Maybe<Array<Maybe<Log>>>
  merlinStructuredLogCreated?: Maybe<StructuredLog>
  merlinStructuredLogUpdated?: Maybe<StructuredLog>
  siteInitJobChanged?: Maybe<SiteInitJob>
  siteProvisionJobChanged?: Maybe<SiteProvisionJob>
  pullRequestCreated?: Maybe<PullRequest>
  pullRequestChanged?: Maybe<PullRequest>
  structuredLogCreated?: Maybe<StructuredLog>
  structuredLogUpdated?: Maybe<StructuredLog>
  buildLogCreated?: Maybe<Array<Maybe<Log>>>
  siteProvisionLogCreated?: Maybe<Array<Maybe<Log>>>
  workspaceHasQueuedItems?: Maybe<Scalars["Boolean"]>
  functionInvocationCreated?: Maybe<FunctionInvocation>
  ssrInvocationCreated?: Maybe<SsrInvocation>
  ssrLogCreated?: Maybe<Log>
  buildReportCreated?: Maybe<Report>
  siteReportCreated?: Maybe<Report>
  contentfulIntegrationAdded?: Maybe<Scalars["String"]>
  sanityIntegrationAdded?: Maybe<Scalars["String"]>
  netlifyIntegrationAdded?: Maybe<Scalars["String"]>
  nowIntegrationAdded?: Maybe<Scalars["String"]>
  googleAuthAdded?: Maybe<Scalars["String"]>
  datoCmsIntegrationAdded?: Maybe<Scalars["String"]>
  sourceOrganizationRepositoryUpdated?: Maybe<Scalars["Boolean"]>
}

export type SubscriptionSiteChangedArgs = {
  id: Scalars["UUID"]
}

export type SubscriptionBuildChangedArgs = {
  id: Scalars["UUID"]
  runnerType: BuildRunnerType
}

export type SubscriptionBuildCreatedArgs = {
  id: Scalars["UUID"]
  runnerType: BuildRunnerType
  pullRequestId?: Maybe<Scalars["UUID"]>
}

export type SubscriptionMerlinStatusChangedArgs = {
  resourceId: Scalars["UUID"]
  resourceType: MerlinSourceEventResourceType
}

export type SubscriptionMerlinSourceEventCreatedArgs = {
  resourceId: Scalars["UUID"]
  resourceType: MerlinSourceEventResourceType
}

export type SubscriptionMerlinSourceEventChangedArgs = {
  sourceEventId: Scalars["ID"]
}

export type SubscriptionMerlinRawLogsCreatedArgs = {
  sourceEventId: Scalars["ID"]
}

export type SubscriptionMerlinStructuredLogCreatedArgs = {
  sourceEventId: Scalars["ID"]
}

export type SubscriptionMerlinStructuredLogUpdatedArgs = {
  sourceEventId: Scalars["ID"]
}

export type SubscriptionSiteInitJobChangedArgs = {
  id: Scalars["ID"]
}

export type SubscriptionSiteProvisionJobChangedArgs = {
  id: Scalars["ID"]
}

export type SubscriptionPullRequestCreatedArgs = {
  siteId: Scalars["UUID"]
}

export type SubscriptionPullRequestChangedArgs = {
  pullRequestId: Scalars["UUID"]
}

export type SubscriptionStructuredLogCreatedArgs = {
  buildId: Scalars["UUID"]
}

export type SubscriptionStructuredLogUpdatedArgs = {
  activityId: Scalars["UUID"]
}

export type SubscriptionBuildLogCreatedArgs = {
  buildId: Scalars["UUID"]
}

export type SubscriptionSiteProvisionLogCreatedArgs = {
  siteProvisionJobId: Scalars["ID"]
}

export type SubscriptionWorkspaceHasQueuedItemsArgs = {
  workspaceId: Scalars["UUID"]
}

export type SubscriptionFunctionInvocationCreatedArgs = {
  functionId: Scalars["UUID"]
  buildId: Scalars["UUID"]
}

export type SubscriptionSsrInvocationCreatedArgs = {
  siteId: Scalars["UUID"]
  buildId: Scalars["UUID"]
}

export type SubscriptionSsrLogCreatedArgs = {
  siteId: Scalars["UUID"]
  buildId: Scalars["UUID"]
}

export type SubscriptionBuildReportCreatedArgs = {
  buildId: Scalars["UUID"]
}

export type SubscriptionSiteReportCreatedArgs = {
  siteId: Scalars["UUID"]
  vendor: ReportPluginVendor
}

export type SubscriptionContentfulIntegrationAddedArgs = {
  siteId: Scalars["UUID"]
}

export type SubscriptionSanityIntegrationAddedArgs = {
  siteId: Scalars["UUID"]
}

export type SubscriptionNetlifyIntegrationAddedArgs = {
  siteId: Scalars["UUID"]
}

export type SubscriptionNowIntegrationAddedArgs = {
  siteId: Scalars["UUID"]
}

export type SubscriptionGoogleAuthAddedArgs = {
  siteId: Scalars["UUID"]
}

export type SubscriptionDatoCmsIntegrationAddedArgs = {
  siteId: Scalars["UUID"]
}

export type SubscriptionSourceOrganizationRepositoryUpdatedArgs = {
  organizationInstallationId: Scalars["String"]
}

export type SubscriptionBootstrapInput = {
  companyName?: Maybe<Scalars["String"]>
  customerName?: Maybe<Scalars["String"]>
  billingEmail?: Maybe<Scalars["String"]>
  quantity?: Maybe<Scalars["Int"]>
  token: Scalars["ID"]
  planId: Scalars["UUID"]
}

export type SubscriptionCreateInput = {
  token: Scalars["ID"]
  planId: Scalars["UUID"]
  organizationId: Scalars["UUID"]
  companyName?: Maybe<Scalars["String"]>
  customerName?: Maybe<Scalars["String"]>
  billingEmail?: Maybe<Scalars["String"]>
  quantity?: Maybe<Scalars["Int"]>
}

export type SubscriptionFeature = {
  __typename?: "SubscriptionFeature"
  max?: Maybe<Scalars["Int"]>
  formattedMax?: Maybe<Scalars["String"]>
  quantity?: Maybe<Scalars["Int"]>
  formattedQuantity?: Maybe<Scalars["String"]>
  amount?: Maybe<Scalars["Int"]>
  formattedAmount?: Maybe<Scalars["USCurrency"]>
}

export type SubscriptionPlan = {
  __typename?: "SubscriptionPlan"
  id: Scalars["UUID"]
  planId: Scalars["String"]
  name: Scalars["String"]
  features: Array<Maybe<Scalars["String"]>>
  usageLimit?: Maybe<Scalars["Int"]>
  buildsTier?: Maybe<MachinePricingTier>
  hostingTier?: Maybe<MachinePricingTier>
  hostingBandwidth?: Maybe<Scalars["String"]>
  hostingPOP?: Maybe<Scalars["String"]>
  hostingRequests?: Maybe<Scalars["String"]>
  baseFeatures?: Maybe<BaseFeatures>
  additionalFeatures?: Maybe<FeaturesSummary>
  totalFeatures?: Maybe<FeaturesSummary>
  amount: Scalars["Int"]
  formattedAmount?: Maybe<Scalars["USCurrency"]>
  interval?: Maybe<BillingInterval>
  intervalCount?: Maybe<Scalars["Int"]>
  isRecommended: Scalars["Boolean"]
  nextBillingDate?: Maybe<Scalars["DateTime"]>
  formattedMonthlyAmount?: Maybe<Scalars["USCurrency"]>
  group?: Maybe<Scalars["String"]>
  quantity?: Maybe<Scalars["Int"]>
}

export type SubscriptionPlanCreateInput = {
  amount?: Maybe<Scalars["Int"]>
  interval?: Maybe<BillingInterval>
  publicName?: Maybe<Scalars["String"]>
  users?: Maybe<Scalars["Int"]>
  usersMax?: Maybe<Scalars["Int"]>
  concurrency?: Maybe<Scalars["Int"]>
  concurrencyMax?: Maybe<Scalars["Int"]>
  requests?: Maybe<Scalars["Int"]>
  requestsMax?: Maybe<Scalars["Int"]>
  sites?: Maybe<Scalars["Int"]>
  thirdPartyHostingIntegrations?: Maybe<Scalars["Int"]>
  domains?: Maybe<Scalars["Int"]>
  bandwidth?: Maybe<Scalars["Int"]>
  bandwidthMax?: Maybe<Scalars["Int"]>
  invocations?: Maybe<Scalars["Int"]>
  invocationsMax?: Maybe<Scalars["Int"]>
  functionTimeout?: Maybe<Scalars["Int"]>
  customSSL?: Maybe<Scalars["Boolean"]>
  globalPops?: Maybe<Scalars["Boolean"]>
  imageCdnRequests?: Maybe<Scalars["Int"]>
  imageCdnRequestsMax?: Maybe<Scalars["Int"]>
  monthlyBuildMinutes?: Maybe<Scalars["Int"]>
  monthlyBuildMinutesMax?: Maybe<Scalars["Int"]>
  totalSiteRoutes?: Maybe<Scalars["Int"]>
  totalSiteRoutesMax?: Maybe<Scalars["Int"]>
}

export enum SubscriptionRepositoryType {
  Individual = "INDIVIDUAL",
  Organization = "ORGANIZATION",
  Enterprise = "ENTERPRISE",
}

export type SubscriptionResubscribeInput = {
  planId: Scalars["UUID"]
  organizationId: Scalars["UUID"]
  quantity?: Maybe<Scalars["Int"]>
}

export type SubscriptionResult = {
  __typename?: "SubscriptionResult"
  token?: Maybe<Scalars["String"]>
  subscription?: Maybe<BillingInformation>
  errors?: Maybe<PaymentError>
}

export enum SubscriptionStatus {
  Free = "FREE",
  Trialing = "TRIALING",
  Active = "ACTIVE",
  PastDue = "PAST_DUE",
  Unpaid = "UNPAID",
  Canceled = "CANCELED",
  All = "ALL",
}

export type Tag = {
  __typename?: "Tag"
  key: Scalars["String"]
  value: Scalars["String"]
  truncatedValue?: Maybe<Scalars["String"]>
}

export type TagInput = {
  key: Scalars["String"]
  value: Scalars["String"]
}

export type UpdateContributorRolesInput = {
  resourceType: CloudResourceType
  resourceId: Scalars["UUID"]
  role: CloudRole
}

export type UpdateContributorRolesResult = {
  __typename?: "UpdateContributorRolesResult"
  validation: MutationResult
}

export type UpdatePaymentResult = {
  __typename?: "UpdatePaymentResult"
  errors?: Maybe<PaymentError>
  creditCard?: Maybe<CreditCard>
}

export enum UsageActionType {
  RealTimeEdit = "REAL_TIME_EDIT",
  RealTimeEditCapped = "REAL_TIME_EDIT_CAPPED",
}

export enum UsageInterval {
  Hourly = "HOURLY",
  Minute = "MINUTE",
  Monthly = "MONTHLY",
  Daily = "DAILY",
  Weekly = "WEEKLY",
  Yearly = "YEARLY",
}

export type UsageSummary = {
  __typename?: "UsageSummary"
  id: Scalars["ID"]
  limitInterval: UsageInterval
  usageInterval: UsageInterval
  total: Scalars["Int"]
  count: Scalars["Int"]
  actionType: UsageActionType
}

export type User = {
  __typename?: "User"
  id: Scalars["UUID"]
  name: Scalars["String"]
  firstName?: Maybe<Scalars["String"]>
  lastName?: Maybe<Scalars["String"]>
  email?: Maybe<Scalars["String"]>
  createdAt?: Maybe<Scalars["DateTime"]>
  avatarUrl?: Maybe<Scalars["String"]>
  nickname?: Maybe<Scalars["String"]>
  leadSource: LeadSource
  isMock?: Maybe<Scalars["Boolean"]>
  invitedToBeta?: Maybe<Scalars["Boolean"]>
  sourceOrganizations?: Maybe<Array<Maybe<SourceOrganization>>>
  source?: Maybe<SourceControlProvider>
  sourceId?: Maybe<Scalars["Int"]>
  leadCapture?: Maybe<UserLeadCapture>
  stats?: Maybe<PermissionsStats>
  banned?: Maybe<Scalars["Boolean"]>
  experimentationUser?: Maybe<Scalars["JSON"]>
}

export type UserInfoInput = {
  firstName?: Maybe<Scalars["String"]>
  lastName?: Maybe<Scalars["String"]>
  email?: Maybe<Scalars["String"]>
}

export type UserLeadCapture = {
  __typename?: "UserLeadCapture"
  id?: Maybe<Scalars["UUID"]>
  resourceId?: Maybe<Scalars["UUID"]>
  name?: Maybe<Scalars["String"]>
  email?: Maybe<Scalars["String"]>
  title?: Maybe<Scalars["String"]>
  companyName?: Maybe<Scalars["String"]>
  projectType?: Maybe<Scalars["String"]>
  cms?: Maybe<Scalars["String"]>
  status?: Maybe<UserLeadCaptureStatus>
}

export enum UserLeadCaptureStatus {
  Incomplete = "INCOMPLETE",
  Complete = "COMPLETE",
}

export type UserListResult = {
  __typename?: "UserListResult"
  users?: Maybe<Array<User>>
  total: Scalars["Int"]
}

export type UserWelcomeInput = {
  firstName: Scalars["String"]
  lastName: Scalars["String"]
  companyEmail: Scalars["String"]
  projectType?: Maybe<Scalars["String"]>
  country?: Maybe<Scalars["String"]>
  region?: Maybe<Scalars["String"]>
  utm_source?: Maybe<Scalars["String"]>
  utm_medium?: Maybe<Scalars["String"]>
  utm_campaign?: Maybe<Scalars["String"]>
  utm_content?: Maybe<Scalars["String"]>
  utm_term?: Maybe<Scalars["String"]>
  referrerUrl?: Maybe<Scalars["String"]>
}

export type VcsConfigSettings = {
  appId: Scalars["String"]
  clientId: Scalars["String"]
  clientSecret: Scalars["String"]
  instanceUrl: Scalars["String"]
  webhookSecret: Scalars["String"]
  privateKey: Scalars["String"]
  name: Scalars["String"]
}

export type VcsHealthCheck = {
  __typename?: "VcsHealthCheck"
  id?: Maybe<Scalars["ID"]>
  name?: Maybe<Scalars["String"]>
  source: SourceControlProvider
  vcsConfigId?: Maybe<Scalars["UUID"]>
  status?: Maybe<VcsHealthCheckStatus>
}

export enum VcsHealthCheckStatus {
  Connected = "CONNECTED",
  Failed = "FAILED",
}

export type WorkspaceMembersResult = {
  __typename?: "WorkspaceMembersResult"
  count?: Maybe<Scalars["Int"]>
  members?: Maybe<Array<Maybe<Contributor>>>
}

export enum GatsbySiteModulesStatus {
  Ready = "READY",
  Unavailable = "UNAVAILABLE",
}
